
export class GodotSourceLibrary
{
  static sourceMap = new Map<string,string>(
    [
      ["CallableMock","tests/servers/test_navigation_server_2d.h"],
["CallableMock","tests/servers/test_navigation_server_3d.h"],
["_TestInstancePlaceholderNode","tests/scene/test_instance_placeholder.h"],
["TestNode","tests/scene/test_node.h"],
["NotificationControlViewport","tests/scene/test_viewport.h"],
["DragStart","tests/scene/test_viewport.h"],
["DragTarget","tests/scene/test_viewport.h"],
["TestArea2D","tests/scene/test_viewport.h"],
["NotificationControlWindow","tests/scene/test_window.h"],
["TestClass","tests/core/variant/test_callable.h"],
["TestBoundUnboundArgumentCount","tests/core/variant/test_callable.h"],
["MethodBindTester","tests/core/object/test_method_bind.h"],
["_TestDerivedObject","tests/core/object/test_object.h"],
["NotificationObjectSuperclass","tests/core/object/test_object.h"],
["NotificationObjectSubclass","tests/core/object/test_object.h"],
["_TestUndoRedoObject","tests/core/object/test_undo_redo.h"],
["m_class_name","tests/core/io/test_resource.h"],
["XRBodyTracker","servers/xr/xr_body_tracker.h"],
["XRControllerTracker","servers/xr/xr_controller_tracker.h"],
["XRFaceTracker","servers/xr/xr_face_tracker.h"],
["XRHandTracker","servers/xr/xr_hand_tracker.h"],
["XRInterface","servers/xr/xr_interface.h"],
["XRInterfaceExtension","servers/xr/xr_interface_extension.h"],
["XRPose","servers/xr/xr_pose.h"],
["XRPositionalTracker","servers/xr/xr_positional_tracker.h"],
["XRServer","servers/xr/xr_server.h"],
["XRTracker","servers/xr/xr_tracker.h"],
["XRVRS","servers/xr/xr_vrs.h"],
["TextServer","servers/text/text_server.h"],
["TextServerManager","servers/text/text_server.h"],
["TextServerDummy","servers/text/text_server_dummy.h"],
["TextServerExtension","servers/text/text_server_extension.h"],
["RenderingDevice","servers/rendering/rendering_device.h"],
["RDTextureFormat","servers/rendering/rendering_device_binds.h"],
["RDTextureView","servers/rendering/rendering_device_binds.h"],
["RDAttachmentFormat","servers/rendering/rendering_device_binds.h"],
["RDFramebufferPass","servers/rendering/rendering_device_binds.h"],
["RDSamplerState","servers/rendering/rendering_device_binds.h"],
["RDVertexAttribute","servers/rendering/rendering_device_binds.h"],
["RDShaderSource","servers/rendering/rendering_device_binds.h"],
["RDShaderSPIRV","servers/rendering/rendering_device_binds.h"],
["RDShaderFile","servers/rendering/rendering_device_binds.h"],
["RDUniform","servers/rendering/rendering_device_binds.h"],
["RDPipelineSpecializationConstant","servers/rendering/rendering_device_binds.h"],
["RDPipelineRasterizationState","servers/rendering/rendering_device_binds.h"],
["RDPipelineMultisampleState","servers/rendering/rendering_device_binds.h"],
["RDPipelineDepthStencilState","servers/rendering/rendering_device_binds.h"],
["RDPipelineColorBlendStateAttachment","servers/rendering/rendering_device_binds.h"],
["RDPipelineColorBlendState","servers/rendering/rendering_device_binds.h"],
["RenderingServer","servers/rendering/rendering_server.h"],
["ShaderIncludeDB","servers/rendering/shader_include_db.h"],
["RenderData","servers/rendering/storage/render_data.h"],
["RenderDataExtension","servers/rendering/storage/render_data.h"],
["RenderSceneBuffersConfiguration","servers/rendering/storage/render_scene_buffers.h"],
["RenderSceneBuffers","servers/rendering/storage/render_scene_buffers.h"],
["RenderSceneBuffersExtension","servers/rendering/storage/render_scene_buffers.h"],
["RenderSceneData","servers/rendering/storage/render_scene_data.h"],
["RenderSceneDataExtension","servers/rendering/storage/render_scene_data.h"],
["FramebufferCacheRD","servers/rendering/renderer_rd/framebuffer_cache_rd.h"],
["UniformSetCacheRD","servers/rendering/renderer_rd/uniform_set_cache_rd.h"],
["RenderBufferCustomDataRD","servers/rendering/renderer_rd/storage_rd/render_buffer_custom_data_rd.h"],
["RenderDataRD","servers/rendering/renderer_rd/storage_rd/render_data_rd.h"],
["RenderSceneBuffersRD","servers/rendering/renderer_rd/storage_rd/render_scene_buffers_rd.h"],
["RenderSceneDataRD","servers/rendering/renderer_rd/storage_rd/render_scene_data_rd.h"],
["RenderBufferDataForwardMobile","servers/rendering/renderer_rd/forward_mobile/render_forward_mobile.h"],
["RenderBufferDataForwardClustered","servers/rendering/renderer_rd/forward_clustered/render_forward_clustered.h"],
["VolumetricFog","servers/rendering/renderer_rd/environment/fog.h"],
["RenderBuffersGI","servers/rendering/renderer_rd/environment/gi.h"],
["SDFGI","servers/rendering/renderer_rd/environment/gi.h"],
["LuminanceBuffers","servers/rendering/renderer_rd/effects/luminance.h"],
["PhysicsDirectBodyState3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsDirectSpaceState3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsServer3DRenderingServerHandler","servers/physics_3d/physics_server_3d.h"],
["PhysicsServer3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsRayQueryParameters3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsPointQueryParameters3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsShapeQueryParameters3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsTestMotionParameters3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsTestMotionResult3D","servers/physics_3d/physics_server_3d.h"],
["PhysicsServer3DManager","servers/physics_3d/physics_server_3d.h"],
["PhysicsDirectBodyState3DDummy","servers/physics_3d/physics_server_3d_dummy.h"],
["PhysicsDirectSpaceState3DDummy","servers/physics_3d/physics_server_3d_dummy.h"],
["PhysicsServer3DDummy","servers/physics_3d/physics_server_3d_dummy.h"],
["PhysicsDirectBodyState3DExtension","servers/physics_3d/physics_server_3d_extension.h"],
["PhysicsDirectSpaceState3DExtension","servers/physics_3d/physics_server_3d_extension.h"],
["PhysicsServer3DExtension","servers/physics_3d/physics_server_3d_extension.h"],
["PhysicsDirectBodyState2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsDirectSpaceState2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsServer2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsRayQueryParameters2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsPointQueryParameters2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsShapeQueryParameters2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsTestMotionParameters2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsTestMotionResult2D","servers/physics_2d/physics_server_2d.h"],
["PhysicsServer2DManager","servers/physics_2d/physics_server_2d.h"],
["PhysicsDirectBodyState2DDummy","servers/physics_2d/physics_server_2d_dummy.h"],
["PhysicsDirectSpaceState2DDummy","servers/physics_2d/physics_server_2d_dummy.h"],
["PhysicsServer2DDummy","servers/physics_2d/physics_server_2d_dummy.h"],
["PhysicsDirectBodyState2DExtension","servers/physics_2d/physics_server_2d_extension.h"],
["PhysicsDirectSpaceState2DExtension","servers/physics_2d/physics_server_2d_extension.h"],
["PhysicsServer2DExtension","servers/physics_2d/physics_server_2d_extension.h"],
["NavigationPathQueryParameters3D","servers/navigation_3d/navigation_path_query_parameters_3d.h"],
["NavigationPathQueryResult3D","servers/navigation_3d/navigation_path_query_result_3d.h"],
["NavigationServer3D","servers/navigation_3d/navigation_server_3d.h"],
["NavigationServer3DDummy","servers/navigation_3d/navigation_server_3d_dummy.h"],
["NavigationPathQueryParameters2D","servers/navigation_2d/navigation_path_query_parameters_2d.h"],
["NavigationPathQueryResult2D","servers/navigation_2d/navigation_path_query_result_2d.h"],
["NavigationServer2D","servers/navigation_2d/navigation_server_2d.h"],
["NavigationServer2DDummy","servers/navigation_2d/navigation_server_2d_dummy.h"],
["MovieWriter","servers/movie_writer/movie_writer.h"],
["MovieWriterPNGWAV","servers/movie_writer/movie_writer_pngwav.h"],
["DisplayServer","servers/display/display_server.h"],
["NativeMenu","servers/display/native_menu.h"],
["CameraFeed","servers/camera/camera_feed.h"],
["CameraServer","servers/camera/camera_server.h"],
["AudioEffectInstance","servers/audio/audio_effect.h"],
["AudioEffect","servers/audio/audio_effect.h"],
["AudioServer","servers/audio/audio_server.h"],
["AudioBusLayout","servers/audio/audio_server.h"],
["AudioSamplePlayback","servers/audio/audio_stream.h"],
["AudioSample","servers/audio/audio_stream.h"],
["AudioStreamPlayback","servers/audio/audio_stream.h"],
["AudioStreamPlaybackResampled","servers/audio/audio_stream.h"],
["AudioStream","servers/audio/audio_stream.h"],
["AudioStreamMicrophone","servers/audio/audio_stream.h"],
["AudioStreamPlaybackMicrophone","servers/audio/audio_stream.h"],
["AudioStreamRandomizer","servers/audio/audio_stream.h"],
["AudioStreamPlaybackRandomizer","servers/audio/audio_stream.h"],
["AudioEffectAmplifyInstance","servers/audio/effects/audio_effect_amplify.h"],
["AudioEffectAmplify","servers/audio/effects/audio_effect_amplify.h"],
["AudioEffectCaptureInstance","servers/audio/effects/audio_effect_capture.h"],
["AudioEffectCapture","servers/audio/effects/audio_effect_capture.h"],
["AudioEffectChorusInstance","servers/audio/effects/audio_effect_chorus.h"],
["AudioEffectChorus","servers/audio/effects/audio_effect_chorus.h"],
["AudioEffectCompressorInstance","servers/audio/effects/audio_effect_compressor.h"],
["AudioEffectCompressor","servers/audio/effects/audio_effect_compressor.h"],
["AudioEffectDelayInstance","servers/audio/effects/audio_effect_delay.h"],
["AudioEffectDelay","servers/audio/effects/audio_effect_delay.h"],
["AudioEffectDistortionInstance","servers/audio/effects/audio_effect_distortion.h"],
["AudioEffectDistortion","servers/audio/effects/audio_effect_distortion.h"],
["AudioEffectEQInstance","servers/audio/effects/audio_effect_eq.h"],
["AudioEffectEQ","servers/audio/effects/audio_effect_eq.h"],
["AudioEffectEQ6","servers/audio/effects/audio_effect_eq.h"],
["AudioEffectEQ10","servers/audio/effects/audio_effect_eq.h"],
["AudioEffectEQ21","servers/audio/effects/audio_effect_eq.h"],
["AudioEffectFilterInstance","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectLowPassFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectHighPassFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectBandPassFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectNotchFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectBandLimitFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectLowShelfFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectHighShelfFilter","servers/audio/effects/audio_effect_filter.h"],
["AudioEffectHardLimiterInstance","servers/audio/effects/audio_effect_hard_limiter.h"],
["AudioEffectHardLimiter","servers/audio/effects/audio_effect_hard_limiter.h"],
["AudioEffectLimiterInstance","servers/audio/effects/audio_effect_limiter.h"],
["AudioEffectLimiter","servers/audio/effects/audio_effect_limiter.h"],
["AudioEffectPannerInstance","servers/audio/effects/audio_effect_panner.h"],
["AudioEffectPanner","servers/audio/effects/audio_effect_panner.h"],
["AudioEffectPhaserInstance","servers/audio/effects/audio_effect_phaser.h"],
["AudioEffectPhaser","servers/audio/effects/audio_effect_phaser.h"],
["AudioEffectPitchShiftInstance","servers/audio/effects/audio_effect_pitch_shift.h"],
["AudioEffectPitchShift","servers/audio/effects/audio_effect_pitch_shift.h"],
["AudioEffectRecordInstance","servers/audio/effects/audio_effect_record.h"],
["AudioEffectRecord","servers/audio/effects/audio_effect_record.h"],
["AudioEffectReverbInstance","servers/audio/effects/audio_effect_reverb.h"],
["AudioEffectReverb","servers/audio/effects/audio_effect_reverb.h"],
["AudioEffectSpectrumAnalyzerInstance","servers/audio/effects/audio_effect_spectrum_analyzer.h"],
["AudioEffectSpectrumAnalyzer","servers/audio/effects/audio_effect_spectrum_analyzer.h"],
["AudioEffectStereoEnhanceInstance","servers/audio/effects/audio_effect_stereo_enhance.h"],
["AudioEffectStereoEnhance","servers/audio/effects/audio_effect_stereo_enhance.h"],
["AudioStreamGenerator","servers/audio/effects/audio_stream_generator.h"],
["AudioStreamGeneratorPlayback","servers/audio/effects/audio_stream_generator.h"],
["ThemeDB","scene/theme/theme_db.h"],
["ThemeContext","scene/theme/theme_db.h"],
["AnimatedTexture","scene/resources/animated_texture.h"],
["Animation","scene/resources/animation.h"],
["AnimationLibrary","scene/resources/animation_library.h"],
["AtlasTexture","scene/resources/atlas_texture.h"],
["AudioStreamPolyphonic","scene/resources/audio_stream_polyphonic.h"],
["AudioStreamPlaybackPolyphonic","scene/resources/audio_stream_polyphonic.h"],
["AudioStreamPlaybackWAV","scene/resources/audio_stream_wav.h"],
["AudioStreamWAV","scene/resources/audio_stream_wav.h"],
["BitMap","scene/resources/bit_map.h"],
["BoneMap","scene/resources/bone_map.h"],
["CameraAttributes","scene/resources/camera_attributes.h"],
["CameraAttributesPractical","scene/resources/camera_attributes.h"],
["CameraAttributesPhysical","scene/resources/camera_attributes.h"],
["CameraTexture","scene/resources/camera_texture.h"],
["CanvasItemMaterial","scene/resources/canvas_item_material.h"],
["ColorPalette","scene/resources/color_palette.h"],
["CompositorEffect","scene/resources/compositor.h"],
["Compositor","scene/resources/compositor.h"],
["CompressedTexture2D","scene/resources/compressed_texture.h"],
["CompressedTextureLayered","scene/resources/compressed_texture.h"],
["CompressedTexture2DArray","scene/resources/compressed_texture.h"],
["CompressedCubemap","scene/resources/compressed_texture.h"],
["CompressedCubemapArray","scene/resources/compressed_texture.h"],
["CompressedTexture3D","scene/resources/compressed_texture.h"],
["Curve","scene/resources/curve.h"],
["Curve2D","scene/resources/curve.h"],
["Curve3D","scene/resources/curve.h"],
["CurveTexture","scene/resources/curve_texture.h"],
["CurveXYZTexture","scene/resources/curve_texture.h"],
["DPITexture","scene/resources/dpi_texture.h"],
["Environment","scene/resources/environment.h"],
["ExternalTexture","scene/resources/external_texture.h"],
["Font","scene/resources/font.h"],
["FontFile","scene/resources/font.h"],
["FontVariation","scene/resources/font.h"],
["SystemFont","scene/resources/font.h"],
["Gradient","scene/resources/gradient.h"],
["GradientTexture1D","scene/resources/gradient_texture.h"],
["GradientTexture2D","scene/resources/gradient_texture.h"],
["ImageTexture","scene/resources/image_texture.h"],
["ImageTextureLayered","scene/resources/image_texture.h"],
["ImageTexture3D","scene/resources/image_texture.h"],
["Texture2DArray","scene/resources/image_texture.h"],
["Cubemap","scene/resources/image_texture.h"],
["CubemapArray","scene/resources/image_texture.h"],
["ImmediateMesh","scene/resources/immediate_mesh.h"],
["LabelSettings","scene/resources/label_settings.h"],
["Material","scene/resources/material.h"],
["ShaderMaterial","scene/resources/material.h"],
["BaseMaterial3D","scene/resources/material.h"],
["StandardMaterial3D","scene/resources/material.h"],
["ORMMaterial3D","scene/resources/material.h"],
["PlaceholderMaterial","scene/resources/material.h"],
["Mesh","scene/resources/mesh.h"],
["MeshConvexDecompositionSettings","scene/resources/mesh.h"],
["ArrayMesh","scene/resources/mesh.h"],
["PlaceholderMesh","scene/resources/mesh.h"],
["MeshDataTool","scene/resources/mesh_data_tool.h"],
["MeshTexture","scene/resources/mesh_texture.h"],
["MultiMesh","scene/resources/multimesh.h"],
["NavigationMesh","scene/resources/navigation_mesh.h"],
["SceneState","scene/resources/packed_scene.h"],
["PackedScene","scene/resources/packed_scene.h"],
["ParticleProcessMaterial","scene/resources/particle_process_material.h"],
["PhysicsMaterial","scene/resources/physics_material.h"],
["PlaceholderTexture2D","scene/resources/placeholder_textures.h"],
["PlaceholderTexture3D","scene/resources/placeholder_textures.h"],
["PlaceholderTextureLayered","scene/resources/placeholder_textures.h"],
["PlaceholderTexture2DArray","scene/resources/placeholder_textures.h"],
["PlaceholderCubemap","scene/resources/placeholder_textures.h"],
["PlaceholderCubemapArray","scene/resources/placeholder_textures.h"],
["PortableCompressedTexture2D","scene/resources/portable_compressed_texture.h"],
["Shader","scene/resources/shader.h"],
["ShaderInclude","scene/resources/shader_include.h"],
["SkeletonProfile","scene/resources/skeleton_profile.h"],
["SkeletonProfileHumanoid","scene/resources/skeleton_profile.h"],
["Sky","scene/resources/sky.h"],
["SpriteFrames","scene/resources/sprite_frames.h"],
["StyleBox","scene/resources/style_box.h"],
["StyleBoxEmpty","scene/resources/style_box.h"],
["StyleBoxFlat","scene/resources/style_box_flat.h"],
["StyleBoxLine","scene/resources/style_box_line.h"],
["StyleBoxTexture","scene/resources/style_box_texture.h"],
["SurfaceTool","scene/resources/surface_tool.h"],
["SyntaxHighlighter","scene/resources/syntax_highlighter.h"],
["CodeHighlighter","scene/resources/syntax_highlighter.h"],
["Texture","scene/resources/texture.h"],
["Texture2D","scene/resources/texture.h"],
["TextureLayered","scene/resources/texture.h"],
["Texture3D","scene/resources/texture.h"],
["Texture2DRD","scene/resources/texture_rd.h"],
["TextureLayeredRD","scene/resources/texture_rd.h"],
["Texture2DArrayRD","scene/resources/texture_rd.h"],
["TextureCubemapRD","scene/resources/texture_rd.h"],
["TextureCubemapArrayRD","scene/resources/texture_rd.h"],
["Texture3DRD","scene/resources/texture_rd.h"],
["TextFile","scene/resources/text_file.h"],
["TextLine","scene/resources/text_line.h"],
["TextParagraph","scene/resources/text_paragraph.h"],
["Theme","scene/resources/theme.h"],
["VideoStreamPlayback","scene/resources/video_stream.h"],
["VideoStream","scene/resources/video_stream.h"],
["VisualShader","scene/resources/visual_shader.h"],
["VisualShaderNode","scene/resources/visual_shader.h"],
["VisualShaderNodeCustom","scene/resources/visual_shader.h"],
["VisualShaderNodeInput","scene/resources/visual_shader.h"],
["VisualShaderNodeOutput","scene/resources/visual_shader.h"],
["VisualShaderNodeParameter","scene/resources/visual_shader.h"],
["VisualShaderNodeParameterRef","scene/resources/visual_shader.h"],
["VisualShaderNodeResizableBase","scene/resources/visual_shader.h"],
["VisualShaderNodeFrame","scene/resources/visual_shader.h"],
["VisualShaderNodeComment","scene/resources/visual_shader.h"],
["VisualShaderNodeGroupBase","scene/resources/visual_shader.h"],
["VisualShaderNodeExpression","scene/resources/visual_shader.h"],
["VisualShaderNodeGlobalExpression","scene/resources/visual_shader.h"],
["VisualShaderNodeVarying","scene/resources/visual_shader.h"],
["VisualShaderNodeVaryingSetter","scene/resources/visual_shader.h"],
["VisualShaderNodeVaryingGetter","scene/resources/visual_shader.h"],
["VisualShaderNodeVectorBase","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFloatConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIntConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUIntConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeBooleanConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeColorConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec2Constant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec3Constant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec4Constant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformConstant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeCurveTexture","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeCurveXYZTexture","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeSample3D","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture2DArray","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture3D","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeCubemap","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeLinearSceneDepth","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeWorldPositionFromDepth","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeScreenNormalWorldSpace","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFloatOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIntOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUIntOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeColorOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformOp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformVecMult","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFloatFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIntFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUIntFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeColorFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUVFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUVPolarCoord","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeDotProduct","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorLen","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeDeterminant","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeClamp","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeDerivativeFunc","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFaceForward","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeOuterProduct","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeStep","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeSmoothStep","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorDistance","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorRefract","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeMix","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorCompose","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformCompose","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVectorDecompose","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformDecompose","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFloatParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIntParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeUIntParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeBooleanParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeColorParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec2Parameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec3Parameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeVec4Parameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTransformParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTextureParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture2DParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTextureParameterTriplanar","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture2DArrayParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeTexture3DParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeCubemapParameter","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIf","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeSwitch","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeFresnel","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeIs","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeCompare","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeMultiplyAdd","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeBillboard","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeDistanceFade","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeProximityFade","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeRandomRange","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeRemap","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeRotationByAxis","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeReroute","scene/resources/visual_shader_nodes.h"],
["VisualShaderNodeParticleEmitter","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleSphereEmitter","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleBoxEmitter","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleRingEmitter","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleMeshEmitter","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleMultiplyByAxisAngle","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleConeVelocity","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleRandomness","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleAccelerator","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleOutput","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeParticleEmit","scene/resources/visual_shader_particle_nodes.h"],
["VisualShaderNodeSDFToScreenUV","scene/resources/visual_shader_sdf_nodes.h"],
["VisualShaderNodeScreenUVToSDF","scene/resources/visual_shader_sdf_nodes.h"],
["VisualShaderNodeTextureSDF","scene/resources/visual_shader_sdf_nodes.h"],
["VisualShaderNodeTextureSDFNormal","scene/resources/visual_shader_sdf_nodes.h"],
["VisualShaderNodeSDFRaymarch","scene/resources/visual_shader_sdf_nodes.h"],
["World2D","scene/resources/world_2d.h"],
["BoxShape3D","scene/resources/3d/box_shape_3d.h"],
["CapsuleShape3D","scene/resources/3d/capsule_shape_3d.h"],
["ConcavePolygonShape3D","scene/resources/3d/concave_polygon_shape_3d.h"],
["ConvexPolygonShape3D","scene/resources/3d/convex_polygon_shape_3d.h"],
["CylinderShape3D","scene/resources/3d/cylinder_shape_3d.h"],
["FogMaterial","scene/resources/3d/fog_material.h"],
["HeightMapShape3D","scene/resources/3d/height_map_shape_3d.h"],
["ImporterMesh","scene/resources/3d/importer_mesh.h"],
["MeshLibrary","scene/resources/3d/mesh_library.h"],
["NavigationMeshSourceGeometryData3D","scene/resources/3d/navigation_mesh_source_geometry_data_3d.h"],
["PrimitiveMesh","scene/resources/3d/primitive_meshes.h"],
["CapsuleMesh","scene/resources/3d/primitive_meshes.h"],
["BoxMesh","scene/resources/3d/primitive_meshes.h"],
["CylinderMesh","scene/resources/3d/primitive_meshes.h"],
["PlaneMesh","scene/resources/3d/primitive_meshes.h"],
["QuadMesh","scene/resources/3d/primitive_meshes.h"],
["PrismMesh","scene/resources/3d/primitive_meshes.h"],
["SphereMesh","scene/resources/3d/primitive_meshes.h"],
["TorusMesh","scene/resources/3d/primitive_meshes.h"],
["PointMesh","scene/resources/3d/primitive_meshes.h"],
["TubeTrailMesh","scene/resources/3d/primitive_meshes.h"],
["RibbonTrailMesh","scene/resources/3d/primitive_meshes.h"],
["TextMesh","scene/resources/3d/primitive_meshes.h"],
["SeparationRayShape3D","scene/resources/3d/separation_ray_shape_3d.h"],
["Shape3D","scene/resources/3d/shape_3d.h"],
["Skin","scene/resources/3d/skin.h"],
["ProceduralSkyMaterial","scene/resources/3d/sky_material.h"],
["PanoramaSkyMaterial","scene/resources/3d/sky_material.h"],
["PhysicalSkyMaterial","scene/resources/3d/sky_material.h"],
["SphereShape3D","scene/resources/3d/sphere_shape_3d.h"],
["World3D","scene/resources/3d/world_3d.h"],
["WorldBoundaryShape3D","scene/resources/3d/world_boundary_shape_3d.h"],
["CapsuleShape2D","scene/resources/2d/capsule_shape_2d.h"],
["CircleShape2D","scene/resources/2d/circle_shape_2d.h"],
["ConcavePolygonShape2D","scene/resources/2d/concave_polygon_shape_2d.h"],
["ConvexPolygonShape2D","scene/resources/2d/convex_polygon_shape_2d.h"],
["NavigationMeshSourceGeometryData2D","scene/resources/2d/navigation_mesh_source_geometry_data_2d.h"],
["NavigationPolygon","scene/resources/2d/navigation_polygon.h"],
["PolygonPathFinder","scene/resources/2d/polygon_path_finder.h"],
["RectangleShape2D","scene/resources/2d/rectangle_shape_2d.h"],
["SegmentShape2D","scene/resources/2d/segment_shape_2d.h"],
["SeparationRayShape2D","scene/resources/2d/separation_ray_shape_2d.h"],
["Shape2D","scene/resources/2d/shape_2d.h"],
["TileMapPattern","scene/resources/2d/tile_set.h"],
["TileSet","scene/resources/2d/tile_set.h"],
["TileSetSource","scene/resources/2d/tile_set.h"],
["TileSetAtlasSource","scene/resources/2d/tile_set.h"],
["TileSetScenesCollectionSource","scene/resources/2d/tile_set.h"],
["TileData","scene/resources/2d/tile_set.h"],
["WorldBoundaryShape2D","scene/resources/2d/world_boundary_shape_2d.h"],
["SkeletonModification2D","scene/resources/2d/skeleton/skeleton_modification_2d.h"],
["SkeletonModification2DCCDIK","scene/resources/2d/skeleton/skeleton_modification_2d_ccdik.h"],
["SkeletonModification2DFABRIK","scene/resources/2d/skeleton/skeleton_modification_2d_fabrik.h"],
["SkeletonModification2DJiggle","scene/resources/2d/skeleton/skeleton_modification_2d_jiggle.h"],
["SkeletonModification2DLookAt","scene/resources/2d/skeleton/skeleton_modification_2d_lookat.h"],
["SkeletonModification2DPhysicalBones","scene/resources/2d/skeleton/skeleton_modification_2d_physicalbones.h"],
["SkeletonModification2DStackHolder","scene/resources/2d/skeleton/skeleton_modification_2d_stackholder.h"],
["SkeletonModification2DTwoBoneIK","scene/resources/2d/skeleton/skeleton_modification_2d_twoboneik.h"],
["SkeletonModificationStack2D","scene/resources/2d/skeleton/skeleton_modification_stack_2d.h"],
["CanvasItem","scene/main/canvas_item.h"],
["CanvasTexture","scene/main/canvas_item.h"],
["CanvasLayer","scene/main/canvas_layer.h"],
["HTTPRequest","scene/main/http_request.h"],
["InstancePlaceholder","scene/main/instance_placeholder.h"],
["MissingNode","scene/main/missing_node.h"],
["MultiplayerAPI","scene/main/multiplayer_api.h"],
["MultiplayerAPIExtension","scene/main/multiplayer_api.h"],
["MultiplayerPeer","scene/main/multiplayer_peer.h"],
["MultiplayerPeerExtension","scene/main/multiplayer_peer.h"],
["Node","scene/main/node.h"],
["ResourcePreloader","scene/main/resource_preloader.h"],
["SceneTreeTimer","scene/main/scene_tree.h"],
["SceneTree","scene/main/scene_tree.h"],
["ShaderGlobalsOverride","scene/main/shader_globals_override.h"],
["StatusIndicator","scene/main/status_indicator.h"],
["Timer","scene/main/timer.h"],
["ViewportTexture","scene/main/viewport.h"],
["Viewport","scene/main/viewport.h"],
["SubViewport","scene/main/viewport.h"],
["Window","scene/main/window.h"],
["AspectRatioContainer","scene/gui/aspect_ratio_container.h"],
["BaseButton","scene/gui/base_button.h"],
["ButtonGroup","scene/gui/base_button.h"],
["BoxContainer","scene/gui/box_container.h"],
["HBoxContainer","scene/gui/box_container.h"],
["VBoxContainer","scene/gui/box_container.h"],
["Button","scene/gui/button.h"],
["CenterContainer","scene/gui/center_container.h"],
["CheckBox","scene/gui/check_box.h"],
["CheckButton","scene/gui/check_button.h"],
["CodeEdit","scene/gui/code_edit.h"],
["ColorPresetButton","scene/gui/color_picker.h"],
["ColorPicker","scene/gui/color_picker.h"],
["ColorPickerButton","scene/gui/color_picker.h"],
["ColorPickerShape","scene/gui/color_picker_shape.h"],
["ColorPickerShapeOKHSRectangle","scene/gui/color_picker_shape.h"],
["ColorPickerShapeOKHLRectangle","scene/gui/color_picker_shape.h"],
["ColorPickerShapeWheel","scene/gui/color_picker_shape.h"],
["ColorPickerShapeCircle","scene/gui/color_picker_shape.h"],
["ColorPickerShapeVHSCircle","scene/gui/color_picker_shape.h"],
["ColorPickerShapeOKHSLCircle","scene/gui/color_picker_shape.h"],
["ColorRect","scene/gui/color_rect.h"],
["Container","scene/gui/container.h"],
["Control","scene/gui/control.h"],
["AcceptDialog","scene/gui/dialogs.h"],
["ConfirmationDialog","scene/gui/dialogs.h"],
["FileDialog","scene/gui/file_dialog.h"],
["FlowContainer","scene/gui/flow_container.h"],
["HFlowContainer","scene/gui/flow_container.h"],
["VFlowContainer","scene/gui/flow_container.h"],
["FoldableContainer","scene/gui/foldable_container.h"],
["FoldableGroup","scene/gui/foldable_container.h"],
["GraphEditFilter","scene/gui/graph_edit.h"],
["GraphEditMinimap","scene/gui/graph_edit.h"],
["GraphEdit","scene/gui/graph_edit.h"],
["GraphElement","scene/gui/graph_element.h"],
["GraphFrame","scene/gui/graph_frame.h"],
["GraphNode","scene/gui/graph_node.h"],
["GridContainer","scene/gui/grid_container.h"],
["ItemList","scene/gui/item_list.h"],
["Label","scene/gui/label.h"],
["LineEdit","scene/gui/line_edit.h"],
["LinkButton","scene/gui/link_button.h"],
["MarginContainer","scene/gui/margin_container.h"],
["MenuBar","scene/gui/menu_bar.h"],
["MenuButton","scene/gui/menu_button.h"],
["NinePatchRect","scene/gui/nine_patch_rect.h"],
["OptionButton","scene/gui/option_button.h"],
["Panel","scene/gui/panel.h"],
["PanelContainer","scene/gui/panel_container.h"],
["Popup","scene/gui/popup.h"],
["PopupPanel","scene/gui/popup.h"],
["PopupMenu","scene/gui/popup_menu.h"],
["ProgressBar","scene/gui/progress_bar.h"],
["Range","scene/gui/range.h"],
["ReferenceRect","scene/gui/reference_rect.h"],
["CharFXTransform","scene/gui/rich_text_effect.h"],
["RichTextEffect","scene/gui/rich_text_effect.h"],
["RichTextLabel","scene/gui/rich_text_label.h"],
["ScrollBar","scene/gui/scroll_bar.h"],
["HScrollBar","scene/gui/scroll_bar.h"],
["VScrollBar","scene/gui/scroll_bar.h"],
["ScrollContainer","scene/gui/scroll_container.h"],
["Separator","scene/gui/separator.h"],
["VSeparator","scene/gui/separator.h"],
["HSeparator","scene/gui/separator.h"],
["Slider","scene/gui/slider.h"],
["HSlider","scene/gui/slider.h"],
["VSlider","scene/gui/slider.h"],
["SpinBoxLineEdit","scene/gui/spin_box.h"],
["SpinBox","scene/gui/spin_box.h"],
["SplitContainerDragger","scene/gui/split_container.h"],
["SplitContainer","scene/gui/split_container.h"],
["HSplitContainer","scene/gui/split_container.h"],
["VSplitContainer","scene/gui/split_container.h"],
["SubViewportContainer","scene/gui/subviewport_container.h"],
["TabBar","scene/gui/tab_bar.h"],
["TabContainer","scene/gui/tab_container.h"],
["TextureButton","scene/gui/texture_button.h"],
["TextureProgressBar","scene/gui/texture_progress_bar.h"],
["TextureRect","scene/gui/texture_rect.h"],
["TextEdit","scene/gui/text_edit.h"],
["TreeItem","scene/gui/tree.h"],
["Tree","scene/gui/tree.h"],
["VideoStreamPlayer","scene/gui/video_stream_player.h"],
["ViewPanner","scene/gui/view_panner.h"],
["RuntimeNodeSelect","scene/debugger/scene_debugger.h"],
["AudioStreamPlayer","scene/audio/audio_stream_player.h"],
["AudioStreamPlayerInternal","scene/audio/audio_stream_player_internal.h"],
["AnimationNodeBlendSpace1D","scene/animation/animation_blend_space_1d.h"],
["AnimationNodeBlendSpace2D","scene/animation/animation_blend_space_2d.h"],
["AnimationNodeAnimation","scene/animation/animation_blend_tree.h"],
["AnimationNodeSync","scene/animation/animation_blend_tree.h"],
["AnimationNodeOneShot","scene/animation/animation_blend_tree.h"],
["AnimationNodeAdd2","scene/animation/animation_blend_tree.h"],
["AnimationNodeAdd3","scene/animation/animation_blend_tree.h"],
["AnimationNodeBlend2","scene/animation/animation_blend_tree.h"],
["AnimationNodeBlend3","scene/animation/animation_blend_tree.h"],
["AnimationNodeSub2","scene/animation/animation_blend_tree.h"],
["AnimationNodeTimeScale","scene/animation/animation_blend_tree.h"],
["AnimationNodeTimeSeek","scene/animation/animation_blend_tree.h"],
["AnimationNodeTransition","scene/animation/animation_blend_tree.h"],
["AnimationNodeOutput","scene/animation/animation_blend_tree.h"],
["AnimationNodeBlendTree","scene/animation/animation_blend_tree.h"],
["AnimationMixer","scene/animation/animation_mixer.h"],
["AnimatedValuesBackup","scene/animation/animation_mixer.h"],
["AnimationNodeExtension","scene/animation/animation_node_extension.h"],
["AnimationNodeStateMachineTransition","scene/animation/animation_node_state_machine.h"],
["AnimationNodeStateMachine","scene/animation/animation_node_state_machine.h"],
["AnimationNodeStateMachinePlayback","scene/animation/animation_node_state_machine.h"],
["AnimationPlayer","scene/animation/animation_player.h"],
["AnimationNode","scene/animation/animation_tree.h"],
["AnimationRootNode","scene/animation/animation_tree.h"],
["AnimationNodeStartState","scene/animation/animation_tree.h"],
["AnimationNodeEndState","scene/animation/animation_tree.h"],
["AnimationTree","scene/animation/animation_tree.h"],
["RootMotionView","scene/animation/root_motion_view.h"],
["Tweener","scene/animation/tween.h"],
["Tween","scene/animation/tween.h"],
["PropertyTweener","scene/animation/tween.h"],
["IntervalTweener","scene/animation/tween.h"],
["CallbackTweener","scene/animation/tween.h"],
["MethodTweener","scene/animation/tween.h"],
["SubtweenTweener","scene/animation/tween.h"],
["AimModifier3D","scene/3d/aim_modifier_3d.h"],
["AudioListener3D","scene/3d/audio_listener_3d.h"],
["AudioStreamPlayer3D","scene/3d/audio_stream_player_3d.h"],
["BoneAttachment3D","scene/3d/bone_attachment_3d.h"],
["BoneConstraint3D","scene/3d/bone_constraint_3d.h"],
["Camera3D","scene/3d/camera_3d.h"],
["ConvertTransformModifier3D","scene/3d/convert_transform_modifier_3d.h"],
["CopyTransformModifier3D","scene/3d/copy_transform_modifier_3d.h"],
["CPUParticles3D","scene/3d/cpu_particles_3d.h"],
["Decal","scene/3d/decal.h"],
["FogVolume","scene/3d/fog_volume.h"],
["GPUParticles3D","scene/3d/gpu_particles_3d.h"],
["GPUParticlesCollision3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesCollisionSphere3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesCollisionBox3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesCollisionSDF3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesCollisionHeightField3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesAttractor3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesAttractorSphere3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesAttractorBox3D","scene/3d/gpu_particles_collision_3d.h"],
["GPUParticlesAttractorVectorField3D","scene/3d/gpu_particles_collision_3d.h"],
["ImporterMeshInstance3D","scene/3d/importer_mesh_instance_3d.h"],
["Label3D","scene/3d/label_3d.h"],
["LightmapDenoiser","scene/3d/lightmapper.h"],
["LightmapRaycaster","scene/3d/lightmapper.h"],
["Lightmapper","scene/3d/lightmapper.h"],
["LightmapGIData","scene/3d/lightmap_gi.h"],
["LightmapGI","scene/3d/lightmap_gi.h"],
["LightmapProbe","scene/3d/lightmap_probe.h"],
["Light3D","scene/3d/light_3d.h"],
["DirectionalLight3D","scene/3d/light_3d.h"],
["OmniLight3D","scene/3d/light_3d.h"],
["SpotLight3D","scene/3d/light_3d.h"],
["LookAtModifier3D","scene/3d/look_at_modifier_3d.h"],
["Marker3D","scene/3d/marker_3d.h"],
["MeshInstance3D","scene/3d/mesh_instance_3d.h"],
["ModifierBoneTarget3D","scene/3d/modifier_bone_target_3d.h"],
["MultiMeshInstance3D","scene/3d/multimesh_instance_3d.h"],
["Node3DGizmo","scene/3d/node_3d.h"],
["Node3D","scene/3d/node_3d.h"],
["Occluder3D","scene/3d/occluder_instance_3d.h"],
["ArrayOccluder3D","scene/3d/occluder_instance_3d.h"],
["QuadOccluder3D","scene/3d/occluder_instance_3d.h"],
["BoxOccluder3D","scene/3d/occluder_instance_3d.h"],
["SphereOccluder3D","scene/3d/occluder_instance_3d.h"],
["PolygonOccluder3D","scene/3d/occluder_instance_3d.h"],
["OccluderInstance3D","scene/3d/occluder_instance_3d.h"],
["Path3D","scene/3d/path_3d.h"],
["PathFollow3D","scene/3d/path_3d.h"],
["ReflectionProbe","scene/3d/reflection_probe.h"],
["RemoteTransform3D","scene/3d/remote_transform_3d.h"],
["RetargetModifier3D","scene/3d/retarget_modifier_3d.h"],
["SkinReference","scene/3d/skeleton_3d.h"],
["Skeleton3D","scene/3d/skeleton_3d.h"],
["SkeletonIK3D","scene/3d/skeleton_ik_3d.h"],
["SkeletonModifier3D","scene/3d/skeleton_modifier_3d.h"],
["SpringBoneCollision3D","scene/3d/spring_bone_collision_3d.h"],
["SpringBoneCollisionCapsule3D","scene/3d/spring_bone_collision_capsule_3d.h"],
["SpringBoneCollisionPlane3D","scene/3d/spring_bone_collision_plane_3d.h"],
["SpringBoneCollisionSphere3D","scene/3d/spring_bone_collision_sphere_3d.h"],
["SpringBoneSimulator3D","scene/3d/spring_bone_simulator_3d.h"],
["SpriteBase3D","scene/3d/sprite_3d.h"],
["Sprite3D","scene/3d/sprite_3d.h"],
["AnimatedSprite3D","scene/3d/sprite_3d.h"],
["VisibleOnScreenNotifier3D","scene/3d/visible_on_screen_notifier_3d.h"],
["VisibleOnScreenEnabler3D","scene/3d/visible_on_screen_notifier_3d.h"],
["VisualInstance3D","scene/3d/visual_instance_3d.h"],
["GeometryInstance3D","scene/3d/visual_instance_3d.h"],
["VoxelGIData","scene/3d/voxel_gi.h"],
["VoxelGI","scene/3d/voxel_gi.h"],
["WorldEnvironment","scene/3d/world_environment.h"],
["XRBodyModifier3D","scene/3d/xr/xr_body_modifier_3d.h"],
["XRFaceModifier3D","scene/3d/xr/xr_face_modifier_3d.h"],
["XRHandModifier3D","scene/3d/xr/xr_hand_modifier_3d.h"],
["XRCamera3D","scene/3d/xr/xr_nodes.h"],
["XRNode3D","scene/3d/xr/xr_nodes.h"],
["XRController3D","scene/3d/xr/xr_nodes.h"],
["XRAnchor3D","scene/3d/xr/xr_nodes.h"],
["XROrigin3D","scene/3d/xr/xr_nodes.h"],
["AnimatableBody3D","scene/3d/physics/animatable_body_3d.h"],
["Area3D","scene/3d/physics/area_3d.h"],
["CharacterBody3D","scene/3d/physics/character_body_3d.h"],
["CollisionObject3D","scene/3d/physics/collision_object_3d.h"],
["CollisionPolygon3D","scene/3d/physics/collision_polygon_3d.h"],
["CollisionShape3D","scene/3d/physics/collision_shape_3d.h"],
["KinematicCollision3D","scene/3d/physics/kinematic_collision_3d.h"],
["PhysicalBone3D","scene/3d/physics/physical_bone_3d.h"],
["PhysicalBoneSimulator3D","scene/3d/physics/physical_bone_simulator_3d.h"],
["PhysicsBody3D","scene/3d/physics/physics_body_3d.h"],
["RayCast3D","scene/3d/physics/ray_cast_3d.h"],
["RigidBody3D","scene/3d/physics/rigid_body_3d.h"],
["ShapeCast3D","scene/3d/physics/shape_cast_3d.h"],
["SoftBody3D","scene/3d/physics/soft_body_3d.h"],
["SpringArm3D","scene/3d/physics/spring_arm_3d.h"],
["StaticBody3D","scene/3d/physics/static_body_3d.h"],
["VehicleWheel3D","scene/3d/physics/vehicle_body_3d.h"],
["VehicleBody3D","scene/3d/physics/vehicle_body_3d.h"],
["ConeTwistJoint3D","scene/3d/physics/joints/cone_twist_joint_3d.h"],
["Generic6DOFJoint3D","scene/3d/physics/joints/generic_6dof_joint_3d.h"],
["HingeJoint3D","scene/3d/physics/joints/hinge_joint_3d.h"],
["Joint3D","scene/3d/physics/joints/joint_3d.h"],
["PinJoint3D","scene/3d/physics/joints/pin_joint_3d.h"],
["SliderJoint3D","scene/3d/physics/joints/slider_joint_3d.h"],
["NavigationAgent3D","scene/3d/navigation/navigation_agent_3d.h"],
["NavigationLink3D","scene/3d/navigation/navigation_link_3d.h"],
["NavigationObstacle3D","scene/3d/navigation/navigation_obstacle_3d.h"],
["NavigationRegion3D","scene/3d/navigation/navigation_region_3d.h"],
["AnimatedSprite2D","scene/2d/animated_sprite_2d.h"],
["AudioListener2D","scene/2d/audio_listener_2d.h"],
["AudioStreamPlayer2D","scene/2d/audio_stream_player_2d.h"],
["BackBufferCopy","scene/2d/back_buffer_copy.h"],
["Camera2D","scene/2d/camera_2d.h"],
["CanvasGroup","scene/2d/canvas_group.h"],
["CanvasModulate","scene/2d/canvas_modulate.h"],
["CPUParticles2D","scene/2d/cpu_particles_2d.h"],
["GPUParticles2D","scene/2d/gpu_particles_2d.h"],
["Light2D","scene/2d/light_2d.h"],
["PointLight2D","scene/2d/light_2d.h"],
["DirectionalLight2D","scene/2d/light_2d.h"],
["OccluderPolygon2D","scene/2d/light_occluder_2d.h"],
["LightOccluder2D","scene/2d/light_occluder_2d.h"],
["Line2D","scene/2d/line_2d.h"],
["Marker2D","scene/2d/marker_2d.h"],
["MeshInstance2D","scene/2d/mesh_instance_2d.h"],
["MultiMeshInstance2D","scene/2d/multimesh_instance_2d.h"],
["Node2D","scene/2d/node_2d.h"],
["Parallax2D","scene/2d/parallax_2d.h"],
["ParallaxBackground","scene/2d/parallax_background.h"],
["ParallaxLayer","scene/2d/parallax_layer.h"],
["Path2D","scene/2d/path_2d.h"],
["PathFollow2D","scene/2d/path_2d.h"],
["Polygon2D","scene/2d/polygon_2d.h"],
["RemoteTransform2D","scene/2d/remote_transform_2d.h"],
["Bone2D","scene/2d/skeleton_2d.h"],
["Skeleton2D","scene/2d/skeleton_2d.h"],
["Sprite2D","scene/2d/sprite_2d.h"],
["TileMap","scene/2d/tile_map.h"],
["DebugQuadrant","scene/2d/tile_map_layer.h"],
["RenderingQuadrant","scene/2d/tile_map_layer.h"],
["PhysicsQuadrant","scene/2d/tile_map_layer.h"],
["TileMapLayer","scene/2d/tile_map_layer.h"],
["VisibleOnScreenNotifier2D","scene/2d/visible_on_screen_notifier_2d.h"],
["VisibleOnScreenEnabler2D","scene/2d/visible_on_screen_notifier_2d.h"],
["AnimatableBody2D","scene/2d/physics/animatable_body_2d.h"],
["Area2D","scene/2d/physics/area_2d.h"],
["CharacterBody2D","scene/2d/physics/character_body_2d.h"],
["CollisionObject2D","scene/2d/physics/collision_object_2d.h"],
["CollisionPolygon2D","scene/2d/physics/collision_polygon_2d.h"],
["CollisionShape2D","scene/2d/physics/collision_shape_2d.h"],
["KinematicCollision2D","scene/2d/physics/kinematic_collision_2d.h"],
["PhysicalBone2D","scene/2d/physics/physical_bone_2d.h"],
["PhysicsBody2D","scene/2d/physics/physics_body_2d.h"],
["RayCast2D","scene/2d/physics/ray_cast_2d.h"],
["RigidBody2D","scene/2d/physics/rigid_body_2d.h"],
["ShapeCast2D","scene/2d/physics/shape_cast_2d.h"],
["StaticBody2D","scene/2d/physics/static_body_2d.h"],
["TouchScreenButton","scene/2d/physics/touch_screen_button.h"],
["DampedSpringJoint2D","scene/2d/physics/joints/damped_spring_joint_2d.h"],
["GrooveJoint2D","scene/2d/physics/joints/groove_joint_2d.h"],
["Joint2D","scene/2d/physics/joints/joint_2d.h"],
["PinJoint2D","scene/2d/physics/joints/pin_joint_2d.h"],
["NavigationAgent2D","scene/2d/navigation/navigation_agent_2d.h"],
["NavigationLink2D","scene/2d/navigation/navigation_link_2d.h"],
["NavigationObstacle2D","scene/2d/navigation/navigation_obstacle_2d.h"],
["NavigationRegion2D","scene/2d/navigation/navigation_region_2d.h"],
["NativeMenuWindows","platform/windows/native_menu_windows.h"],
["EditorExportPlatformWindows","platform/windows/export/export_plugin.h"],
["IPWeb","platform/web/ip_web.h"],
["EditorExportPlatformWeb","platform/web/export/export_plugin.h"],
["WebToolsEditorPlugin","platform/web/editor/web_tools_editor_plugin.h"],
["JavaScriptObject","platform/web/api/javascript_bridge_singleton.h"],
["JavaScriptBridge","platform/web/api/javascript_bridge_singleton.h"],
["visionOS","platform/visionos/visionos.h"],
["EditorExportPlatformVisionOS","platform/visionos/export/export_plugin.h"],
["NativeMenuMacOS","platform/macos/native_menu_macos.h"],
["EditorExportPlatformMacOS","platform/macos/export/export_plugin.h"],
["GameViewDebuggerMacOS","platform/macos/editor/embedded_game_view_plugin.h"],
["GameViewPluginMacOS","platform/macos/editor/embedded_game_view_plugin.h"],
["LayerHost","platform/macos/editor/embedded_process_macos.h"],
["EmbeddedProcessMacOS","platform/macos/editor/embedded_process_macos.h"],
["EditorExportPlatformLinuxBSD","platform/linuxbsd/export/export_plugin.h"],
["iOS","platform/ios/ios.h"],
["EditorExportPlatformIOS","platform/ios/export/export_plugin.h"],
["EditorExportPlatformAndroid","platform/android/export/export_plugin.h"],
["JavaClass","platform/android/api/java_class_wrapper.h"],
["JavaObject","platform/android/api/java_class_wrapper.h"],
["JavaClassWrapper","platform/android/api/java_class_wrapper.h"],
["JNISingleton","platform/android/api/jni_singleton.h"],
["ZIPPacker","modules/zip/zip_packer.h"],
["ZIPReader","modules/zip/zip_reader.h"],
["WebXRInterface","modules/webxr/webxr_interface.h"],
["WebXRInterfaceJS","modules/webxr/webxr_interface_js.h"],
["WebSocketMultiplayerPeer","modules/websocket/websocket_multiplayer_peer.h"],
["WebSocketPeer","modules/websocket/websocket_peer.h"],
["EditorDebuggerServerWebSocket","modules/websocket/editor/editor_debugger_server_websocket.h"],
["WebRTCDataChannel","modules/webrtc/webrtc_data_channel.h"],
["WebRTCDataChannelExtension","modules/webrtc/webrtc_data_channel_extension.h"],
["WebRTCDataChannelJS","modules/webrtc/webrtc_data_channel_js.h"],
["WebRTCMultiplayerPeer","modules/webrtc/webrtc_multiplayer_peer.h"],
["WebRTCPeerConnection","modules/webrtc/webrtc_peer_connection.h"],
["WebRTCPeerConnectionExtension","modules/webrtc/webrtc_peer_connection_extension.h"],
["WebRTCPeerConnectionJS","modules/webrtc/webrtc_peer_connection_js.h"],
["AudioStreamPlaybackOggVorbis","modules/vorbis/audio_stream_ogg_vorbis.h"],
["AudioStreamOggVorbis","modules/vorbis/audio_stream_ogg_vorbis.h"],
["ResourceImporterOggVorbis","modules/vorbis/resource_importer_ogg_vorbis.h"],
["UPNP","modules/upnp/upnp.h"],
["UPNPDevice","modules/upnp/upnp_device.h"],
["UPNPDeviceMiniUPNP","modules/upnp/upnp_device_miniupnp.h"],
["UPNPMiniUPNP","modules/upnp/upnp_miniupnp.h"],
["VideoStreamPlaybackTheora","modules/theora/video_stream_theora.h"],
["VideoStreamTheora","modules/theora/video_stream_theora.h"],
["MovieWriterOGV","modules/theora/editor/movie_writer_ogv.h"],
["TextServerFallback","modules/text_server_fb/text_server_fb.h"],
["TextServerAdvanced","modules/text_server_adv/text_server_adv.h"],
["RegExMatch","modules/regex/regex.h"],
["RegEx","modules/regex/regex.h"],
["LightmapRaycasterEmbree","modules/raycast/lightmap_raycaster_embree.h"],
["StaticRaycasterEmbree","modules/raycast/static_raycaster_embree.h"],
["OpenXRAPIExtension","modules/openxr/openxr_api_extension.h"],
["OpenXRInterface","modules/openxr/openxr_interface.h"],
["OpenXRStructureBase","modules/openxr/openxr_structure.h"],
["OpenXRCompositionLayer","modules/openxr/scene/openxr_composition_layer.h"],
["OpenXRCompositionLayerCylinder","modules/openxr/scene/openxr_composition_layer_cylinder.h"],
["OpenXRCompositionLayerEquirect","modules/openxr/scene/openxr_composition_layer_equirect.h"],
["OpenXRCompositionLayerQuad","modules/openxr/scene/openxr_composition_layer_quad.h"],
["OpenXRHand","modules/openxr/scene/openxr_hand.h"],
["OpenXRRenderModel","modules/openxr/scene/openxr_render_model.h"],
["OpenXRRenderModelManager","modules/openxr/scene/openxr_render_model_manager.h"],
["OpenXRVisibilityMask","modules/openxr/scene/openxr_visibility_mask.h"],
["OpenXRCompositionLayerDepthExtension","modules/openxr/extensions/openxr_composition_layer_depth_extension.h"],
["OpenXRCompositionLayerExtension","modules/openxr/extensions/openxr_composition_layer_extension.h"],
["OpenXRDebugUtilsExtension","modules/openxr/extensions/openxr_debug_utils_extension.h"],
["OpenXRDPadBindingExtension","modules/openxr/extensions/openxr_dpad_binding_extension.h"],
["OpenXRDpadBindingModifier","modules/openxr/extensions/openxr_dpad_binding_extension.h"],
["OpenXRExtensionWrapper","modules/openxr/extensions/openxr_extension_wrapper.h"],
["OpenXRExtensionWrapperExtension","modules/openxr/extensions/openxr_extension_wrapper_extension.h"],
["OpenXREyeGazeInteractionExtension","modules/openxr/extensions/openxr_eye_gaze_interaction.h"],
["OpenXRDisplayRefreshRateExtension","modules/openxr/extensions/openxr_fb_display_refresh_rate_extension.h"],
["OpenXRFBFoveationExtension","modules/openxr/extensions/openxr_fb_foveation_extension.h"],
["OpenXRFBUpdateSwapchainExtension","modules/openxr/extensions/openxr_fb_update_swapchain_extension.h"],
["OpenXRFutureResult","modules/openxr/extensions/openxr_future_extension.h"],
["OpenXRFutureExtension","modules/openxr/extensions/openxr_future_extension.h"],
["OpenXRHandInteractionExtension","modules/openxr/extensions/openxr_hand_interaction_extension.h"],
["OpenXRHandTrackingExtension","modules/openxr/extensions/openxr_hand_tracking_extension.h"],
["OpenXRHTCControllerExtension","modules/openxr/extensions/openxr_htc_controller_extension.h"],
["OpenXRHTCViveTrackerExtension","modules/openxr/extensions/openxr_htc_vive_tracker_extension.h"],
["OpenXRHuaweiControllerExtension","modules/openxr/extensions/openxr_huawei_controller_extension.h"],
["OpenXRLocalFloorExtension","modules/openxr/extensions/openxr_local_floor_extension.h"],
["OpenXRMetaControllerExtension","modules/openxr/extensions/openxr_meta_controller_extension.h"],
["OpenXRML2ControllerExtension","modules/openxr/extensions/openxr_ml2_controller_extension.h"],
["OpenXRMxInkExtension","modules/openxr/extensions/openxr_mxink_extension.h"],
["OpenXRPalmPoseExtension","modules/openxr/extensions/openxr_palm_pose_extension.h"],
["OpenXRPicoControllerExtension","modules/openxr/extensions/openxr_pico_controller_extension.h"],
["OpenXRRenderModelData","modules/openxr/extensions/openxr_render_model_extension.h"],
["OpenXRRenderModelExtension","modules/openxr/extensions/openxr_render_model_extension.h"],
["OpenXRValveAnalogThresholdExtension","modules/openxr/extensions/openxr_valve_analog_threshold_extension.h"],
["OpenXRAnalogThresholdModifier","modules/openxr/extensions/openxr_valve_analog_threshold_extension.h"],
["OpenXRVisibilityMaskExtension","modules/openxr/extensions/openxr_visibility_mask_extension.h"],
["OpenXRWMRControllerExtension","modules/openxr/extensions/openxr_wmr_controller_extension.h"],
["OpenXRSpatialCapabilityConfigurationAnchor","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRSpatialComponentAnchorList","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRSpatialContextPersistenceConfig","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRSpatialComponentPersistenceList","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRAnchorTracker","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRSpatialAnchorCapability","modules/openxr/extensions/spatial_entities/openxr_spatial_anchor.h"],
["OpenXRSpatialCapabilityConfigurationBaseHeader","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialEntityTracker","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentData","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentBounded2DList","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentBounded3DList","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentParentList","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentMesh2DList","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialComponentMesh3DList","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialQueryResultData","modules/openxr/extensions/spatial_entities/openxr_spatial_entities.h"],
["OpenXRSpatialEntityExtension","modules/openxr/extensions/spatial_entities/openxr_spatial_entity_extension.h"],
["OpenXRSpatialCapabilityConfigurationQrCode","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialCapabilityConfigurationMicroQrCode","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialCapabilityConfigurationAruco","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialCapabilityConfigurationAprilTag","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialComponentMarkerList","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRMarkerTracker","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialMarkerTrackingCapability","modules/openxr/extensions/spatial_entities/openxr_spatial_marker_tracking.h"],
["OpenXRSpatialCapabilityConfigurationPlaneTracking","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRSpatialComponentPlaneAlignmentList","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRSpatialComponentPolygon2DList","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRSpatialComponentPlaneSemanticLabelList","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRPlaneTracker","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRSpatialPlaneTrackingCapability","modules/openxr/extensions/spatial_entities/openxr_spatial_plane_tracking.h"],
["OpenXRActionEditor","modules/openxr/editor/openxr_action_editor.h"],
["OpenXRActionMapEditor","modules/openxr/editor/openxr_action_map_editor.h"],
["OpenXRActionSetEditor","modules/openxr/editor/openxr_action_set_editor.h"],
["OpenXRBindingModifiersDialog","modules/openxr/editor/openxr_binding_modifiers_dialog.h"],
["EditorPropertyActionSet","modules/openxr/editor/openxr_binding_modifier_editor.h"],
["EditorPropertyBindingPath","modules/openxr/editor/openxr_binding_modifier_editor.h"],
["EditorInspectorPluginBindingModifier","modules/openxr/editor/openxr_binding_modifier_editor.h"],
["OpenXRBindingModifierEditor","modules/openxr/editor/openxr_binding_modifier_editor.h"],
["OpenXREditorPlugin","modules/openxr/editor/openxr_editor_plugin.h"],
["OpenXRInteractionProfileEditorBase","modules/openxr/editor/openxr_interaction_profile_editor.h"],
["OpenXRInteractionProfileEditor","modules/openxr/editor/openxr_interaction_profile_editor.h"],
["OpenXRSelectActionDialog","modules/openxr/editor/openxr_select_action_dialog.h"],
["OpenXRSelectInteractionProfileDialog","modules/openxr/editor/openxr_select_interaction_profile_dialog.h"],
["OpenXRSelectRuntime","modules/openxr/editor/openxr_select_runtime.h"],
["OpenXRAction","modules/openxr/action_map/openxr_action.h"],
["OpenXRActionMap","modules/openxr/action_map/openxr_action_map.h"],
["OpenXRActionSet","modules/openxr/action_map/openxr_action_set.h"],
["OpenXRBindingModifier","modules/openxr/action_map/openxr_binding_modifier.h"],
["OpenXRIPBindingModifier","modules/openxr/action_map/openxr_binding_modifier.h"],
["OpenXRActionBindingModifier","modules/openxr/action_map/openxr_binding_modifier.h"],
["OpenXRHapticBase","modules/openxr/action_map/openxr_haptic_feedback.h"],
["OpenXRHapticVibration","modules/openxr/action_map/openxr_haptic_feedback.h"],
["OpenXRIPBinding","modules/openxr/action_map/openxr_interaction_profile.h"],
["OpenXRInteractionProfile","modules/openxr/action_map/openxr_interaction_profile.h"],
["OpenXRInteractionProfileMetadata","modules/openxr/action_map/openxr_interaction_profile_metadata.h"],
["OggPacketSequence","modules/ogg/ogg_packet_sequence.h"],
["OggPacketSequencePlayback","modules/ogg/ogg_packet_sequence.h"],
["ObjectDBProfilerPanel","modules/objectdb_profiler/editor/objectdb_profiler_panel.h"],
["ObjectDBProfilerPlugin","modules/objectdb_profiler/editor/objectdb_profiler_plugin.h"],
["ObjectDBProfilerDebuggerPlugin","modules/objectdb_profiler/editor/objectdb_profiler_plugin.h"],
["SnapshotDataObject","modules/objectdb_profiler/editor/snapshot_data.h"],
["GameStateSnapshot","modules/objectdb_profiler/editor/snapshot_data.h"],
["GameStateSnapshotRef","modules/objectdb_profiler/editor/snapshot_data.h"],
["SnapshotClassView","modules/objectdb_profiler/editor/data_viewers/class_view.h"],
["SnapshotNodeView","modules/objectdb_profiler/editor/data_viewers/node_view.h"],
["SnapshotObjectView","modules/objectdb_profiler/editor/data_viewers/object_view.h"],
["SnapshotRefCountedView","modules/objectdb_profiler/editor/data_viewers/refcounted_view.h"],
["SpanningHeader","modules/objectdb_profiler/editor/data_viewers/shared_controls.h"],
["DarkPanelContainer","modules/objectdb_profiler/editor/data_viewers/shared_controls.h"],
["TreeSortAndFilterBar","modules/objectdb_profiler/editor/data_viewers/shared_controls.h"],
["SnapshotView","modules/objectdb_profiler/editor/data_viewers/snapshot_view.h"],
["SummaryBlurb","modules/objectdb_profiler/editor/data_viewers/summary_view.h"],
["SnapshotSummaryView","modules/objectdb_profiler/editor/data_viewers/summary_view.h"],
["FastNoiseLite","modules/noise/fastnoise_lite.h"],
["Noise","modules/noise/noise.h"],
["NoiseTexture2D","modules/noise/noise_texture_2d.h"],
["NoiseTexture3D","modules/noise/noise_texture_3d.h"],
["NoiseTextureTester","modules/noise/tests/test_noise_texture_2d.h"],
["NoiseTexture3DTester","modules/noise/tests/test_noise_texture_3d.h"],
["NoiseEditorPlugin","modules/noise/editor/noise_editor_plugin.h"],
["NavLinkIteration3D","modules/navigation_3d/nav_link_3d.h"],
["NavigationLink3DEditorPlugin","modules/navigation_3d/editor/navigation_link_3d_editor_plugin.h"],
["NavigationLink3DGizmoPlugin","modules/navigation_3d/editor/navigation_link_3d_gizmo_plugin.h"],
["NavigationObstacle3DGizmoPlugin","modules/navigation_3d/editor/navigation_obstacle_3d_editor_plugin.h"],
["NavigationObstacle3DEditorPlugin","modules/navigation_3d/editor/navigation_obstacle_3d_editor_plugin.h"],
["NavigationRegion3DEditor","modules/navigation_3d/editor/navigation_region_3d_editor_plugin.h"],
["NavigationRegion3DEditorPlugin","modules/navigation_3d/editor/navigation_region_3d_editor_plugin.h"],
["NavigationRegion3DGizmoPlugin","modules/navigation_3d/editor/navigation_region_3d_gizmo_plugin.h"],
["NavigationMeshGenerator","modules/navigation_3d/3d/navigation_mesh_generator.h"],
["NavBaseIteration3D","modules/navigation_3d/3d/nav_base_iteration_3d.h"],
["NavRegionIteration3D","modules/navigation_3d/3d/nav_region_iteration_3d.h"],
["NavLinkIteration2D","modules/navigation_2d/nav_link_2d.h"],
["NavigationLink2DEditor","modules/navigation_2d/editor/navigation_link_2d_editor_plugin.h"],
["NavigationLink2DEditorPlugin","modules/navigation_2d/editor/navigation_link_2d_editor_plugin.h"],
["NavigationObstacle2DEditor","modules/navigation_2d/editor/navigation_obstacle_2d_editor_plugin.h"],
["NavigationObstacle2DEditorPlugin","modules/navigation_2d/editor/navigation_obstacle_2d_editor_plugin.h"],
["NavigationRegion2DEditor","modules/navigation_2d/editor/navigation_region_2d_editor_plugin.h"],
["NavigationRegion2DEditorPlugin","modules/navigation_2d/editor/navigation_region_2d_editor_plugin.h"],
["GodotNavigationServer2D","modules/navigation_2d/2d/godot_navigation_server_2d.h"],
["NavBaseIteration2D","modules/navigation_2d/2d/nav_base_iteration_2d.h"],
["NavRegionIteration2D","modules/navigation_2d/2d/nav_region_iteration_2d.h"],
["MultiplayerSpawner","modules/multiplayer/multiplayer_spawner.h"],
["MultiplayerSynchronizer","modules/multiplayer/multiplayer_synchronizer.h"],
["SceneCacheInterface","modules/multiplayer/scene_cache_interface.h"],
["OfflineMultiplayerPeer","modules/multiplayer/scene_multiplayer.h"],
["SceneMultiplayer","modules/multiplayer/scene_multiplayer.h"],
["SceneReplicationConfig","modules/multiplayer/scene_replication_config.h"],
["SceneReplicationInterface","modules/multiplayer/scene_replication_interface.h"],
["SceneRPCInterface","modules/multiplayer/scene_rpc_interface.h"],
["Wasp","modules/multiplayer/tests/test_multiplayer_spawner.h"],
["SpawnWasps","modules/multiplayer/tests/test_multiplayer_spawner.h"],
["EditorNetworkProfiler","modules/multiplayer/editor/editor_network_profiler.h"],
["MultiplayerEditorDebugger","modules/multiplayer/editor/multiplayer_editor_plugin.h"],
["MultiplayerEditorPlugin","modules/multiplayer/editor/multiplayer_editor_plugin.h"],
["ReplicationEditor","modules/multiplayer/editor/replication_editor.h"],
["CSharpScript","modules/mono/csharp_script.h"],
["ManagedCallableMiddleman","modules/mono/csharp_script.h"],
["GodotSharp","modules/mono/mono_gd/gd_mono.h"],
["MobileVRInterface","modules/mobile_vr/mobile_vr_interface.h"],
["AudioStreamPlaybackMP3","modules/minimp3/audio_stream_mp3.h"],
["AudioStreamMP3","modules/minimp3/audio_stream_mp3.h"],
["ResourceImporterMP3","modules/minimp3/resource_importer_mp3.h"],
["LightmapperRD","modules/lightmapper_rd/lightmapper_rd.h"],
["JSONRPC","modules/jsonrpc/jsonrpc.h"],
["MovieWriterMJPEG","modules/jpg/movie_writer_mjpeg.h"],
["JoltPhysicsServer3D","modules/jolt_physics/jolt_physics_server_3d.h"],
["JoltPhysicsDirectSpaceState3D","modules/jolt_physics/spaces/jolt_physics_direct_space_state_3d.h"],
["JoltPhysicsDirectBodyState3D","modules/jolt_physics/objects/jolt_physics_direct_body_state_3d.h"],
["AudioStreamInteractive","modules/interactive_music/audio_stream_interactive.h"],
["AudioStreamPlaybackInteractive","modules/interactive_music/audio_stream_interactive.h"],
["AudioStreamPlaylist","modules/interactive_music/audio_stream_playlist.h"],
["AudioStreamPlaybackPlaylist","modules/interactive_music/audio_stream_playlist.h"],
["AudioStreamSynchronized","modules/interactive_music/audio_stream_synchronized.h"],
["AudioStreamPlaybackSynchronized","modules/interactive_music/audio_stream_synchronized.h"],
["AudioStreamInteractiveTransitionEditor","modules/interactive_music/editor/audio_stream_interactive_editor_plugin.h"],
["EditorInspectorPluginAudioStreamInteractive","modules/interactive_music/editor/audio_stream_interactive_editor_plugin.h"],
["AudioStreamInteractiveEditorPlugin","modules/interactive_music/editor/audio_stream_interactive_editor_plugin.h"],
["GridMap","modules/gridmap/grid_map.h"],
["GridMapEditor","modules/gridmap/editor/grid_map_editor_plugin.h"],
["GridMapEditorPlugin","modules/gridmap/editor/grid_map_editor_plugin.h"],
["GodotPhysicsDirectBodyState3D","modules/godot_physics_3d/godot_body_direct_state_3d.h"],
["GodotPhysicsServer3D","modules/godot_physics_3d/godot_physics_server_3d.h"],
["GodotPhysicsDirectSpaceState3D","modules/godot_physics_3d/godot_space_3d.h"],
["GodotPhysicsDirectBodyState2D","modules/godot_physics_2d/godot_body_direct_state_2d.h"],
["GodotPhysicsServer2D","modules/godot_physics_2d/godot_physics_server_2d.h"],
["GodotPhysicsDirectSpaceState2D","modules/godot_physics_2d/godot_space_2d.h"],
["GLTFDocument","modules/gltf/gltf_document.h"],
["GLTFState","modules/gltf/gltf_state.h"],
["GLTFAccessor","modules/gltf/structures/gltf_accessor.h"],
["GLTFAnimation","modules/gltf/structures/gltf_animation.h"],
["GLTFBufferView","modules/gltf/structures/gltf_buffer_view.h"],
["GLTFCamera","modules/gltf/structures/gltf_camera.h"],
["GLTFMesh","modules/gltf/structures/gltf_mesh.h"],
["GLTFNode","modules/gltf/structures/gltf_node.h"],
["GLTFObjectModelProperty","modules/gltf/structures/gltf_object_model_property.h"],
["GLTFSkeleton","modules/gltf/structures/gltf_skeleton.h"],
["GLTFSkin","modules/gltf/structures/gltf_skin.h"],
["GLTFTexture","modules/gltf/structures/gltf_texture.h"],
["GLTFTextureSampler","modules/gltf/structures/gltf_texture_sampler.h"],
["GLTFDocumentExtension","modules/gltf/extensions/gltf_document_extension.h"],
["GLTFDocumentExtensionConvertImporterMesh","modules/gltf/extensions/gltf_document_extension_convert_importer_mesh.h"],
["GLTFDocumentExtensionTextureKTX","modules/gltf/extensions/gltf_document_extension_texture_ktx.h"],
["GLTFDocumentExtensionTextureWebP","modules/gltf/extensions/gltf_document_extension_texture_webp.h"],
["GLTFLight","modules/gltf/extensions/gltf_light.h"],
["GLTFSpecGloss","modules/gltf/extensions/gltf_spec_gloss.h"],
["GLTFDocumentExtensionPhysics","modules/gltf/extensions/physics/gltf_document_extension_physics.h"],
["GLTFPhysicsBody","modules/gltf/extensions/physics/gltf_physics_body.h"],
["GLTFPhysicsShape","modules/gltf/extensions/physics/gltf_physics_shape.h"],
["EditorImportBlendRunner","modules/gltf/editor/editor_import_blend_runner.h"],
["SceneExporterGLTFPlugin","modules/gltf/editor/editor_scene_exporter_gltf_plugin.h"],
["EditorSceneExporterGLTFSettings","modules/gltf/editor/editor_scene_exporter_gltf_settings.h"],
["EditorSceneFormatImporterBlend","modules/gltf/editor/editor_scene_importer_blend.h"],
["EditorFileSystemImportFormatSupportQueryBlend","modules/gltf/editor/editor_scene_importer_blend.h"],
["EditorSceneFormatImporterGLTF","modules/gltf/editor/editor_scene_importer_gltf.h"],
["GDScriptNativeClass","modules/gdscript/gdscript.h"],
["GDScript","modules/gdscript/gdscript.h"],
["GDScriptFunctionState","modules/gdscript/gdscript_function.h"],
["GDScriptLanguageProtocol","modules/gdscript/language_server/gdscript_language_protocol.h"],
["GDScriptLanguageServer","modules/gdscript/language_server/gdscript_language_server.h"],
["GDScriptTextDocument","modules/gdscript/language_server/gdscript_text_document.h"],
["GDScriptWorkspace","modules/gdscript/language_server/gdscript_workspace.h"],
["GDScriptSyntaxHighlighter","modules/gdscript/editor/gdscript_highlighter.h"],
["GDScriptEditorTranslationParserPlugin","modules/gdscript/editor/gdscript_translation_parser_plugin.h"],
["FBXDocument","modules/fbx/fbx_document.h"],
["FBXState","modules/fbx/fbx_state.h"],
["EditorSceneFormatImporterFBX2GLTF","modules/fbx/editor/editor_scene_importer_fbx2gltf.h"],
["EditorSceneFormatImporterUFBX","modules/fbx/editor/editor_scene_importer_ufbx.h"],
["ENetConnection","modules/enet/enet_connection.h"],
["ENetMultiplayerPeer","modules/enet/enet_multiplayer_peer.h"],
["ENetPacketPeer","modules/enet/enet_packet_peer.h"],
["CSGShape3D","modules/csg/csg_shape.h"],
["CSGCombiner3D","modules/csg/csg_shape.h"],
["CSGPrimitive3D","modules/csg/csg_shape.h"],
["CSGMesh3D","modules/csg/csg_shape.h"],
["CSGSphere3D","modules/csg/csg_shape.h"],
["CSGBox3D","modules/csg/csg_shape.h"],
["CSGCylinder3D","modules/csg/csg_shape.h"],
["CSGTorus3D","modules/csg/csg_shape.h"],
["CSGPolygon3D","modules/csg/csg_shape.h"],
["CSGShape3DGizmoPlugin","modules/csg/editor/csg_gizmos.h"],
["CSGShapeEditor","modules/csg/editor/csg_gizmos.h"],
["EditorPluginCSG","modules/csg/editor/csg_gizmos.h"],
["Performance","main/performance.h"],
["EditorSelection","editor/editor_data.h"],
["EditorInterface","editor/editor_interface.h"],
["EditorLog","editor/editor_log.h"],
["EditorMainScreen","editor/editor_main_screen.h"],
["EditorNode","editor/editor_node.h"],
["EditorUndoRedoManager","editor/editor_undo_redo_manager.h"],
["EditorVCSInterface","editor/version_control/editor_vcs_interface.h"],
["VersionControlEditorPlugin","editor/version_control/version_control_editor_plugin.h"],
["EditorLocaleDialog","editor/translations/editor_locale_dialog.h"],
["EditorTranslationParserPlugin","editor/translations/editor_translation_parser.h"],
["EditorTranslationPreviewButton","editor/translations/editor_translation_preview_button.h"],
["EditorTranslationPreviewMenu","editor/translations/editor_translation_preview_menu.h"],
["LocalizationEditor","editor/translations/localization_editor.h"],
["PackedSceneEditorTranslationParserPlugin","editor/translations/packed_scene_translation_parser_plugin.h"],
["EditorTheme","editor/themes/editor_theme.h"],
["EditorNativeShaderSourceVisualizer","editor/shader/editor_native_shader_source_visualizer.h"],
["ShaderCreateDialog","editor/shader/shader_create_dialog.h"],
["ShaderEditor","editor/shader/shader_editor.h"],
["ShaderEditorPlugin","editor/shader/shader_editor_plugin.h"],
["ShaderFileEditor","editor/shader/shader_file_editor_plugin.h"],
["ShaderFileEditorPlugin","editor/shader/shader_file_editor_plugin.h"],
["ShaderGlobalsEditor","editor/shader/shader_globals_editor.h"],
["GDShaderSyntaxHighlighter","editor/shader/text_shader_editor.h"],
["ShaderTextEditor","editor/shader/text_shader_editor.h"],
["TextShaderEditor","editor/shader/text_shader_editor.h"],
["VisualShaderNodePlugin","editor/shader/visual_shader_editor_plugin.h"],
["VSGraphNode","editor/shader/visual_shader_editor_plugin.h"],
["VSRerouteNode","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderGraphPlugin","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderEditedProperty","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderEditor","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderNodePluginDefault","editor/shader/visual_shader_editor_plugin.h"],
["EditorPropertyVisualShaderMode","editor/shader/visual_shader_editor_plugin.h"],
["EditorInspectorVisualShaderModePlugin","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderNodePortPreview","editor/shader/visual_shader_editor_plugin.h"],
["VisualShaderConversionPlugin","editor/shader/visual_shader_editor_plugin.h"],
["ShaderBakerExportPluginPlatformD3D12","editor/shader/shader_baker/shader_baker_export_plugin_platform_d3d12.h"],
["ShaderBakerExportPluginPlatformVulkan","editor/shader/shader_baker/shader_baker_export_plugin_platform_vulkan.h"],
["ActionMapEditor","editor/settings/action_map_editor.h"],
["EditorAutoloadSettings","editor/settings/editor_autoload_settings.h"],
["EditorBuildProfile","editor/settings/editor_build_profile.h"],
["EditorBuildProfileManager","editor/settings/editor_build_profile.h"],
["EditorCommandPalette","editor/settings/editor_command_palette.h"],
["EditorEventSearchBar","editor/settings/editor_event_search_bar.h"],
["EditorFeatureProfile","editor/settings/editor_feature_profile.h"],
["EditorFeatureProfileManager","editor/settings/editor_feature_profile.h"],
["EditorLayoutsDialog","editor/settings/editor_layouts_dialog.h"],
["EditorSettings","editor/settings/editor_settings.h"],
["EditorSettingsDialog","editor/settings/editor_settings_dialog.h"],
["EditorSettingsPropertyWrapper","editor/settings/editor_settings_dialog.h"],
["EditorSettingsInspectorPlugin","editor/settings/editor_settings_dialog.h"],
["EventListenerLineEdit","editor/settings/event_listener_line_edit.h"],
["InputEventConfigurationDialog","editor/settings/input_event_configuration_dialog.h"],
["ProjectSettingsEditor","editor/settings/project_settings_editor.h"],
["EditorScript","editor/script/editor_script.h"],
["EditorScriptPlugin","editor/script/editor_script_plugin.h"],
["FindInFiles","editor/script/find_in_files.h"],
["FindInFilesDialog","editor/script/find_in_files.h"],
["FindInFilesPanel","editor/script/find_in_files.h"],
["ScriptCreateDialog","editor/script/script_create_dialog.h"],
["EditorSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["EditorStandardSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["EditorPlainTextSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["EditorJSONSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["EditorMarkdownSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["EditorConfigFileSyntaxHighlighter","editor/script/script_editor_plugin.h"],
["ScriptEditorQuickOpen","editor/script/script_editor_plugin.h"],
["ScriptEditorBase","editor/script/script_editor_plugin.h"],
["ScriptEditor","editor/script/script_editor_plugin.h"],
["ScriptEditorPlugin","editor/script/script_editor_plugin.h"],
["ConnectionInfoDialog","editor/script/script_text_editor.h"],
["ScriptTextEditor","editor/script/script_text_editor.h"],
["TextEditor","editor/script/text_editor.h"],
["CanvasItemEditorSelectedItem","editor/scene/canvas_item_editor_plugin.h"],
["CanvasItemEditor","editor/scene/canvas_item_editor_plugin.h"],
["CanvasItemEditorPlugin","editor/scene/canvas_item_editor_plugin.h"],
["CanvasItemEditorViewport","editor/scene/canvas_item_editor_plugin.h"],
["ConnectDialog","editor/scene/connections_dialog.h"],
["ConnectionsDock","editor/scene/connections_dialog.h"],
["CurveEdit","editor/scene/curve_editor_plugin.h"],
["CurveEditor","editor/scene/curve_editor_plugin.h"],
["EditorInspectorPluginCurve","editor/scene/curve_editor_plugin.h"],
["CurveEditorPlugin","editor/scene/curve_editor_plugin.h"],
["CurvePreviewGenerator","editor/scene/curve_editor_plugin.h"],
["EditorSceneTabs","editor/scene/editor_scene_tabs.h"],
["GradientEdit","editor/scene/gradient_editor_plugin.h"],
["GradientEditor","editor/scene/gradient_editor_plugin.h"],
["EditorInspectorPluginGradient","editor/scene/gradient_editor_plugin.h"],
["GradientEditorPlugin","editor/scene/gradient_editor_plugin.h"],
["GroupSettingsEditor","editor/scene/group_settings_editor.h"],
["MaterialEditor","editor/scene/material_editor_plugin.h"],
["EditorInspectorPluginMaterial","editor/scene/material_editor_plugin.h"],
["MaterialEditorPlugin","editor/scene/material_editor_plugin.h"],
["ParticleProcessMaterialConversionPlugin","editor/scene/material_editor_plugin.h"],
["CanvasItemMaterialConversionPlugin","editor/scene/material_editor_plugin.h"],
["PackedSceneEditor","editor/scene/packed_scene_editor_plugin.h"],
["EditorInspectorPluginPackedScene","editor/scene/packed_scene_editor_plugin.h"],
["PackedSceneEditorPlugin","editor/scene/packed_scene_editor_plugin.h"],
["ParticlesEditorPlugin","editor/scene/particles_editor_plugin.h"],
["ParticleProcessMaterialMinMaxPropertyEditor","editor/scene/particle_process_material_editor_plugin.h"],
["EditorInspectorParticleProcessMaterialPlugin","editor/scene/particle_process_material_editor_plugin.h"],
["RenameDialog","editor/scene/rename_dialog.h"],
["ReparentDialog","editor/scene/reparent_dialog.h"],
["ResourcePreloaderEditor","editor/scene/resource_preloader_editor_plugin.h"],
["ResourcePreloaderEditorPlugin","editor/scene/resource_preloader_editor_plugin.h"],
["SceneCreateDialog","editor/scene/scene_create_dialog.h"],
["SceneTreeEditor","editor/scene/scene_tree_editor.h"],
["SceneTreeDialog","editor/scene/scene_tree_editor.h"],
["ClipboardSpriteFrames","editor/scene/sprite_frames_editor_plugin.h"],
["SpriteFramesEditor","editor/scene/sprite_frames_editor_plugin.h"],
["SpriteFramesEditorPlugin","editor/scene/sprite_frames_editor_plugin.h"],
["BitMapEditor","editor/scene/texture/bit_map_editor_plugin.h"],
["EditorInspectorPluginBitMap","editor/scene/texture/bit_map_editor_plugin.h"],
["BitMapEditorPlugin","editor/scene/texture/bit_map_editor_plugin.h"],
["ColorChannelSelector","editor/scene/texture/color_channel_selector.h"],
["GradientTexture2DEdit","editor/scene/texture/gradient_texture_2d_editor_plugin.h"],
["GradientTexture2DEditor","editor/scene/texture/gradient_texture_2d_editor_plugin.h"],
["EditorInspectorPluginGradientTexture2D","editor/scene/texture/gradient_texture_2d_editor_plugin.h"],
["GradientTexture2DEditorPlugin","editor/scene/texture/gradient_texture_2d_editor_plugin.h"],
["Texture3DEditor","editor/scene/texture/texture_3d_editor_plugin.h"],
["EditorInspectorPlugin3DTexture","editor/scene/texture/texture_3d_editor_plugin.h"],
["Texture3DEditorPlugin","editor/scene/texture/texture_3d_editor_plugin.h"],
["TexturePreview","editor/scene/texture/texture_editor_plugin.h"],
["EditorInspectorPluginTexture","editor/scene/texture/texture_editor_plugin.h"],
["TextureEditorPlugin","editor/scene/texture/texture_editor_plugin.h"],
["TextureLayeredEditor","editor/scene/texture/texture_layered_editor_plugin.h"],
["EditorInspectorPluginLayeredTexture","editor/scene/texture/texture_layered_editor_plugin.h"],
["TextureLayeredEditorPlugin","editor/scene/texture/texture_layered_editor_plugin.h"],
["TextureRegionEditor","editor/scene/texture/texture_region_editor_plugin.h"],
["EditorInspectorPluginTextureRegion","editor/scene/texture/texture_region_editor_plugin.h"],
["TextureRegionEditorPlugin","editor/scene/texture/texture_region_editor_plugin.h"],
["ControlPositioningWarning","editor/scene/gui/control_editor_plugin.h"],
["EditorPropertyAnchorsPreset","editor/scene/gui/control_editor_plugin.h"],
["EditorPropertySizeFlags","editor/scene/gui/control_editor_plugin.h"],
["EditorInspectorPluginControl","editor/scene/gui/control_editor_plugin.h"],
["ControlEditorPopupButton","editor/scene/gui/control_editor_plugin.h"],
["ControlEditorPresetPicker","editor/scene/gui/control_editor_plugin.h"],
["AnchorPresetPicker","editor/scene/gui/control_editor_plugin.h"],
["SizeFlagPresetPicker","editor/scene/gui/control_editor_plugin.h"],
["ControlEditorToolbar","editor/scene/gui/control_editor_plugin.h"],
["ControlEditorPlugin","editor/scene/gui/control_editor_plugin.h"],
["EditorPropertyFontMetaObject","editor/scene/gui/font_config_plugin.h"],
["EditorPropertyFontOTObject","editor/scene/gui/font_config_plugin.h"],
["EditorPropertyFontMetaOverride","editor/scene/gui/font_config_plugin.h"],
["EditorPropertyOTVariation","editor/scene/gui/font_config_plugin.h"],
["EditorPropertyOTFeatures","editor/scene/gui/font_config_plugin.h"],
["EditorInspectorPluginFontVariation","editor/scene/gui/font_config_plugin.h"],
["FontPreview","editor/scene/gui/font_config_plugin.h"],
["EditorInspectorPluginFontPreview","editor/scene/gui/font_config_plugin.h"],
["EditorPropertyFontNamesArray","editor/scene/gui/font_config_plugin.h"],
["EditorInspectorPluginSystemFont","editor/scene/gui/font_config_plugin.h"],
["FontEditorPlugin","editor/scene/gui/font_config_plugin.h"],
["MarginContainerEditorPlugin","editor/scene/gui/margin_container_editor_plugin.h"],
["StyleBoxPreview","editor/scene/gui/style_box_editor_plugin.h"],
["EditorInspectorPluginStyleBox","editor/scene/gui/style_box_editor_plugin.h"],
["StyleBoxEditorPlugin","editor/scene/gui/style_box_editor_plugin.h"],
["ThemeItemImportTree","editor/scene/gui/theme_editor_plugin.h"],
["ThemeItemEditorDialog","editor/scene/gui/theme_editor_plugin.h"],
["ThemeTypeDialog","editor/scene/gui/theme_editor_plugin.h"],
["ThemeTypeEditor","editor/scene/gui/theme_editor_plugin.h"],
["ThemeEditor","editor/scene/gui/theme_editor_plugin.h"],
["ThemeEditorPlugin","editor/scene/gui/theme_editor_plugin.h"],
["ThemeEditorPreview","editor/scene/gui/theme_editor_preview.h"],
["DefaultThemeEditorPreview","editor/scene/gui/theme_editor_preview.h"],
["SceneThemeEditorPreview","editor/scene/gui/theme_editor_preview.h"],
["BoneMapperButton","editor/scene/3d/bone_map_editor_plugin.h"],
["BoneMapperItem","editor/scene/3d/bone_map_editor_plugin.h"],
["BonePicker","editor/scene/3d/bone_map_editor_plugin.h"],
["BoneMapper","editor/scene/3d/bone_map_editor_plugin.h"],
["BoneMapEditor","editor/scene/3d/bone_map_editor_plugin.h"],
["EditorInspectorPluginBoneMap","editor/scene/3d/bone_map_editor_plugin.h"],
["BoneMapEditorPlugin","editor/scene/3d/bone_map_editor_plugin.h"],
["Camera3DEditor","editor/scene/3d/camera_3d_editor_plugin.h"],
["Camera3DPreview","editor/scene/3d/camera_3d_editor_plugin.h"],
["EditorInspectorPluginCamera3DPreview","editor/scene/3d/camera_3d_editor_plugin.h"],
["Camera3DEditorPlugin","editor/scene/3d/camera_3d_editor_plugin.h"],
["GPUParticlesCollisionSDF3DEditorPlugin","editor/scene/3d/gpu_particles_collision_sdf_editor_plugin.h"],
["LightmapGIEditorPlugin","editor/scene/3d/lightmap_gi_editor_plugin.h"],
["StandardMaterial3DConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["ORMMaterial3DConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["ProceduralSkyMaterialConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["PanoramaSkyMaterialConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["PhysicalSkyMaterialConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["FogMaterialConversionPlugin","editor/scene/3d/material_3d_conversion_plugins.h"],
["MeshEditor","editor/scene/3d/mesh_editor_plugin.h"],
["EditorInspectorPluginMesh","editor/scene/3d/mesh_editor_plugin.h"],
["MeshEditorPlugin","editor/scene/3d/mesh_editor_plugin.h"],
["MeshInstance3DEditor","editor/scene/3d/mesh_instance_3d_editor_plugin.h"],
["MeshInstance3DEditorPlugin","editor/scene/3d/mesh_instance_3d_editor_plugin.h"],
["MeshLibraryEditor","editor/scene/3d/mesh_library_editor_plugin.h"],
["MeshLibraryEditorPlugin","editor/scene/3d/mesh_library_editor_plugin.h"],
["MultiMeshEditor","editor/scene/3d/multimesh_editor_plugin.h"],
["MultiMeshEditorPlugin","editor/scene/3d/multimesh_editor_plugin.h"],
["EditorNode3DGizmo","editor/scene/3d/node_3d_editor_gizmos.h"],
["EditorNode3DGizmoPlugin","editor/scene/3d/node_3d_editor_gizmos.h"],
["ViewportRotationControl","editor/scene/3d/node_3d_editor_plugin.h"],
["Node3DEditorViewport","editor/scene/3d/node_3d_editor_plugin.h"],
["Node3DEditorSelectedItem","editor/scene/3d/node_3d_editor_plugin.h"],
["Node3DEditorViewportContainer","editor/scene/3d/node_3d_editor_plugin.h"],
["Node3DEditor","editor/scene/3d/node_3d_editor_plugin.h"],
["PreviewSunEnvPopup","editor/scene/3d/node_3d_editor_plugin.h"],
["Node3DEditorPlugin","editor/scene/3d/node_3d_editor_plugin.h"],
["ViewportNavigationControl","editor/scene/3d/node_3d_editor_plugin.h"],
["OccluderInstance3DEditorPlugin","editor/scene/3d/occluder_instance_3d_editor_plugin.h"],
["Particles3DEditorPlugin","editor/scene/3d/particles_3d_editor_plugin.h"],
["GPUParticles3DEditorPlugin","editor/scene/3d/particles_3d_editor_plugin.h"],
["CPUParticles3DEditorPlugin","editor/scene/3d/particles_3d_editor_plugin.h"],
["Path3DGizmo","editor/scene/3d/path_3d_editor_plugin.h"],
["Path3DGizmoPlugin","editor/scene/3d/path_3d_editor_plugin.h"],
["Path3DEditorPlugin","editor/scene/3d/path_3d_editor_plugin.h"],
["Polygon3DEditor","editor/scene/3d/polygon_3d_editor_plugin.h"],
["Polygon3DEditorPlugin","editor/scene/3d/polygon_3d_editor_plugin.h"],
["EditorPropertyRootMotion","editor/scene/3d/root_motion_editor_plugin.h"],
["EditorInspectorRootMotionPlugin","editor/scene/3d/root_motion_editor_plugin.h"],
["BonePropertiesEditor","editor/scene/3d/skeleton_3d_editor_plugin.h"],
["Skeleton3DEditor","editor/scene/3d/skeleton_3d_editor_plugin.h"],
["EditorInspectorPluginSkeleton","editor/scene/3d/skeleton_3d_editor_plugin.h"],
["Skeleton3DEditorPlugin","editor/scene/3d/skeleton_3d_editor_plugin.h"],
["Skeleton3DGizmoPlugin","editor/scene/3d/skeleton_3d_editor_plugin.h"],
["SkeletonIK3DEditorPlugin","editor/scene/3d/skeleton_ik_3d_editor_plugin.h"],
["VoxelGIEditorPlugin","editor/scene/3d/voxel_gi_editor_plugin.h"],
["PhysicalBone3DEditor","editor/scene/3d/physics/physical_bone_3d_editor_plugin.h"],
["PhysicalBone3DEditorPlugin","editor/scene/3d/physics/physical_bone_3d_editor_plugin.h"],
["AudioListener3DGizmoPlugin","editor/scene/3d/gizmos/audio_listener_3d_gizmo_plugin.h"],
["AudioStreamPlayer3DGizmoPlugin","editor/scene/3d/gizmos/audio_stream_player_3d_gizmo_plugin.h"],
["Camera3DGizmoPlugin","editor/scene/3d/gizmos/camera_3d_gizmo_plugin.h"],
["CPUParticles3DGizmoPlugin","editor/scene/3d/gizmos/cpu_particles_3d_gizmo_plugin.h"],
["DecalGizmoPlugin","editor/scene/3d/gizmos/decal_gizmo_plugin.h"],
["FogVolumeGizmoPlugin","editor/scene/3d/gizmos/fog_volume_gizmo_plugin.h"],
["GeometryInstance3DGizmoPlugin","editor/scene/3d/gizmos/geometry_instance_3d_gizmo_plugin.h"],
["Gizmo3DHelper","editor/scene/3d/gizmos/gizmo_3d_helper.h"],
["GPUParticles3DGizmoPlugin","editor/scene/3d/gizmos/gpu_particles_3d_gizmo_plugin.h"],
["GPUParticlesCollision3DGizmoPlugin","editor/scene/3d/gizmos/gpu_particles_collision_3d_gizmo_plugin.h"],
["Label3DGizmoPlugin","editor/scene/3d/gizmos/label_3d_gizmo_plugin.h"],
["LightmapGIGizmoPlugin","editor/scene/3d/gizmos/lightmap_gi_gizmo_plugin.h"],
["LightmapProbeGizmoPlugin","editor/scene/3d/gizmos/lightmap_probe_gizmo_plugin.h"],
["Light3DGizmoPlugin","editor/scene/3d/gizmos/light_3d_gizmo_plugin.h"],
["Marker3DGizmoPlugin","editor/scene/3d/gizmos/marker_3d_gizmo_plugin.h"],
["MeshInstance3DGizmoPlugin","editor/scene/3d/gizmos/mesh_instance_3d_gizmo_plugin.h"],
["OccluderInstance3DGizmoPlugin","editor/scene/3d/gizmos/occluder_instance_3d_gizmo_plugin.h"],
["Particles3DEmissionShapeGizmoPlugin","editor/scene/3d/gizmos/particles_3d_emission_shape_gizmo_plugin.h"],
["ReflectionProbeGizmoPlugin","editor/scene/3d/gizmos/reflection_probe_gizmo_plugin.h"],
["SpringBoneSimulator3DGizmoPlugin","editor/scene/3d/gizmos/spring_bone_3d_gizmo_plugin.h"],
["SpringBoneCollision3DGizmoPlugin","editor/scene/3d/gizmos/spring_bone_3d_gizmo_plugin.h"],
["SpriteBase3DGizmoPlugin","editor/scene/3d/gizmos/sprite_base_3d_gizmo_plugin.h"],
["VisibleOnScreenNotifier3DGizmoPlugin","editor/scene/3d/gizmos/visible_on_screen_notifier_3d_gizmo_plugin.h"],
["VoxelGIGizmoPlugin","editor/scene/3d/gizmos/voxel_gi_gizmo_plugin.h"],
["CollisionObject3DGizmoPlugin","editor/scene/3d/gizmos/physics/collision_object_3d_gizmo_plugin.h"],
["CollisionPolygon3DGizmoPlugin","editor/scene/3d/gizmos/physics/collision_polygon_3d_gizmo_plugin.h"],
["CollisionShape3DGizmoPlugin","editor/scene/3d/gizmos/physics/collision_shape_3d_gizmo_plugin.h"],
["Joint3DGizmoPlugin","editor/scene/3d/gizmos/physics/joint_3d_gizmo_plugin.h"],
["PhysicalBone3DGizmoPlugin","editor/scene/3d/gizmos/physics/physics_bone_3d_gizmo_plugin.h"],
["RayCast3DGizmoPlugin","editor/scene/3d/gizmos/physics/ray_cast_3d_gizmo_plugin.h"],
["ShapeCast3DGizmoPlugin","editor/scene/3d/gizmos/physics/shape_cast_3d_gizmo_plugin.h"],
["SoftBody3DGizmoPlugin","editor/scene/3d/gizmos/physics/soft_body_3d_gizmo_plugin.h"],
["SpringArm3DGizmoPlugin","editor/scene/3d/gizmos/physics/spring_arm_3d_gizmo_plugin.h"],
["VehicleWheel3DGizmoPlugin","editor/scene/3d/gizmos/physics/vehicle_body_3d_gizmo_plugin.h"],
["AbstractPolygon2DEditor","editor/scene/2d/abstract_polygon_2d_editor.h"],
["AbstractPolygon2DEditorPlugin","editor/scene/2d/abstract_polygon_2d_editor.h"],
["Camera2DEditor","editor/scene/2d/camera_2d_editor_plugin.h"],
["Camera2DEditorPlugin","editor/scene/2d/camera_2d_editor_plugin.h"],
["LightOccluder2DEditor","editor/scene/2d/light_occluder_2d_editor_plugin.h"],
["LightOccluder2DEditorPlugin","editor/scene/2d/light_occluder_2d_editor_plugin.h"],
["Line2DEditor","editor/scene/2d/line_2d_editor_plugin.h"],
["Line2DEditorPlugin","editor/scene/2d/line_2d_editor_plugin.h"],
["ParallaxBackgroundEditorPlugin","editor/scene/2d/parallax_background_editor_plugin.h"],
["Particles2DEditorPlugin","editor/scene/2d/particles_2d_editor_plugin.h"],
["GPUParticles2DEditorPlugin","editor/scene/2d/particles_2d_editor_plugin.h"],
["CPUParticles2DEditorPlugin","editor/scene/2d/particles_2d_editor_plugin.h"],
["Path2DEditor","editor/scene/2d/path_2d_editor_plugin.h"],
["Path2DEditorPlugin","editor/scene/2d/path_2d_editor_plugin.h"],
["Polygon2DEditor","editor/scene/2d/polygon_2d_editor_plugin.h"],
["Polygon2DEditorPlugin","editor/scene/2d/polygon_2d_editor_plugin.h"],
["Skeleton2DEditor","editor/scene/2d/skeleton_2d_editor_plugin.h"],
["Skeleton2DEditorPlugin","editor/scene/2d/skeleton_2d_editor_plugin.h"],
["Sprite2DEditor","editor/scene/2d/sprite_2d_editor_plugin.h"],
["Sprite2DEditorPlugin","editor/scene/2d/sprite_2d_editor_plugin.h"],
["AtlasMergingDialog","editor/scene/2d/tiles/atlas_merging_dialog.h"],
["TilesEditorUtils","editor/scene/2d/tiles/tiles_editor_plugin.h"],
["TileMapEditorPlugin","editor/scene/2d/tiles/tiles_editor_plugin.h"],
["TileSetEditorPlugin","editor/scene/2d/tiles/tiles_editor_plugin.h"],
["TileAtlasView","editor/scene/2d/tiles/tile_atlas_view.h"],
["TileDataEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["DummyObject","editor/scene/2d/tiles/tile_data_editors.h"],
["GenericTilePolygonEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataDefaultEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataTextureOriginEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataPositionEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataYSortEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataOcclusionShapeEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataCollisionEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataTerrainsEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileDataNavigationEditor","editor/scene/2d/tiles/tile_data_editors.h"],
["TileMapLayerEditorTilesPlugin","editor/scene/2d/tiles/tile_map_layer_editor.h"],
["TileMapLayerEditorTerrainsPlugin","editor/scene/2d/tiles/tile_map_layer_editor.h"],
["TileMapLayerEditor","editor/scene/2d/tiles/tile_map_layer_editor.h"],
["TileProxiesManagerDialog","editor/scene/2d/tiles/tile_proxies_manager_dialog.h"],
["TileSetAtlasSourceEditor","editor/scene/2d/tiles/tile_set_atlas_source_editor.h"],
["TileSetAtlasSourceProxyObject","editor/scene/2d/tiles/tile_set_atlas_source_editor.h"],
["AtlasTileProxyObject","editor/scene/2d/tiles/tile_set_atlas_source_editor.h"],
["EditorPropertyTilePolygon","editor/scene/2d/tiles/tile_set_atlas_source_editor.h"],
["EditorInspectorPluginTileData","editor/scene/2d/tiles/tile_set_atlas_source_editor.h"],
["TileSetEditor","editor/scene/2d/tiles/tile_set_editor.h"],
["TileSourceInspectorPlugin","editor/scene/2d/tiles/tile_set_editor.h"],
["TileSetScenesCollectionSourceEditor","editor/scene/2d/tiles/tile_set_scenes_collection_source_editor.h"],
["TileSetScenesCollectionProxyObject","editor/scene/2d/tiles/tile_set_scenes_collection_source_editor.h"],
["SceneTileProxyObject","editor/scene/2d/tiles/tile_set_scenes_collection_source_editor.h"],
["Cast2DEditor","editor/scene/2d/physics/cast_2d_editor_plugin.h"],
["Cast2DEditorPlugin","editor/scene/2d/physics/cast_2d_editor_plugin.h"],
["CollisionPolygon2DEditor","editor/scene/2d/physics/collision_polygon_2d_editor_plugin.h"],
["CollisionPolygon2DEditorPlugin","editor/scene/2d/physics/collision_polygon_2d_editor_plugin.h"],
["CollisionShape2DEditor","editor/scene/2d/physics/collision_shape_2d_editor_plugin.h"],
["CollisionShape2DEditorPlugin","editor/scene/2d/physics/collision_shape_2d_editor_plugin.h"],
["EditorRunBar","editor/run/editor_run_bar.h"],
["EditorRunNative","editor/run/editor_run_native.h"],
["EmbeddedProcessBase","editor/run/embedded_process.h"],
["EmbeddedProcess","editor/run/embedded_process.h"],
["GameViewDebugger","editor/run/game_view_plugin.h"],
["GameView","editor/run/game_view_plugin.h"],
["GameViewPluginBase","editor/run/game_view_plugin.h"],
["GameViewPlugin","editor/run/game_view_plugin.h"],
["RunInstancesDialog","editor/run/run_instances_dialog.h"],
["ProjectUpgradeTool","editor/project_upgrade/project_upgrade_tool.h"],
["EngineUpdateLabel","editor/project_manager/engine_update_label.h"],
["ProjectDialog","editor/project_manager/project_dialog.h"],
["ProjectListItemControl","editor/project_manager/project_list.h"],
["ProjectList","editor/project_manager/project_list.h"],
["ProjectManager","editor/project_manager/project_manager.h"],
["ProjectTag","editor/project_manager/project_tag.h"],
["QuickSettingsDialog","editor/project_manager/quick_settings_dialog.h"],
["EditorPlugin","editor/plugins/editor_plugin.h"],
["EditorPluginSettings","editor/plugins/editor_plugin_settings.h"],
["EditorResourceConversionPlugin","editor/plugins/editor_resource_conversion_plugin.h"],
["PluginConfigDialog","editor/plugins/plugin_config_dialog.h"],
["AddMetadataDialog","editor/inspector/add_metadata_dialog.h"],
["EditorContextMenuPlugin","editor/inspector/editor_context_menu_plugin.h"],
["EditorContextMenuPluginManager","editor/inspector/editor_context_menu_plugin.h"],
["EditorInspectorActionButton","editor/inspector/editor_inspector.h"],
["EditorProperty","editor/inspector/editor_inspector.h"],
["EditorInspectorPlugin","editor/inspector/editor_inspector.h"],
["EditorInspectorCategory","editor/inspector/editor_inspector.h"],
["EditorInspectorSection","editor/inspector/editor_inspector.h"],
["ArrayPanelContainer","editor/inspector/editor_inspector.h"],
["EditorInspectorArray","editor/inspector/editor_inspector.h"],
["EditorPaginator","editor/inspector/editor_inspector.h"],
["EditorInspector","editor/inspector/editor_inspector.h"],
["EditorTexturePreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorImagePreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorBitmapPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorPackedScenePreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorMaterialPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorScriptPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorAudioStreamPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorMeshPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorFontPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorGradientPreviewPlugin","editor/inspector/editor_preview_plugins.h"],
["EditorPropertyNil","editor/inspector/editor_properties.h"],
["EditorPropertyVariant","editor/inspector/editor_properties.h"],
["EditorPropertyText","editor/inspector/editor_properties.h"],
["EditorPropertyMultilineText","editor/inspector/editor_properties.h"],
["EditorPropertyTextEnum","editor/inspector/editor_properties.h"],
["EditorPropertyPath","editor/inspector/editor_properties.h"],
["EditorPropertyLocale","editor/inspector/editor_properties.h"],
["EditorPropertyClassName","editor/inspector/editor_properties.h"],
["EditorPropertyCheck","editor/inspector/editor_properties.h"],
["EditorPropertyEnum","editor/inspector/editor_properties.h"],
["EditorPropertyFlags","editor/inspector/editor_properties.h"],
["EditorPropertyLayersGrid","editor/inspector/editor_properties.h"],
["EditorPropertyLayers","editor/inspector/editor_properties.h"],
["EditorPropertyInteger","editor/inspector/editor_properties.h"],
["EditorPropertyObjectID","editor/inspector/editor_properties.h"],
["EditorPropertySignal","editor/inspector/editor_properties.h"],
["EditorPropertyCallable","editor/inspector/editor_properties.h"],
["EditorPropertyFloat","editor/inspector/editor_properties.h"],
["EditorPropertyEasing","editor/inspector/editor_properties.h"],
["EditorPropertyRect2","editor/inspector/editor_properties.h"],
["EditorPropertyRect2i","editor/inspector/editor_properties.h"],
["EditorPropertyPlane","editor/inspector/editor_properties.h"],
["EditorPropertyQuaternion","editor/inspector/editor_properties.h"],
["EditorPropertyAABB","editor/inspector/editor_properties.h"],
["EditorPropertyTransform2D","editor/inspector/editor_properties.h"],
["EditorPropertyBasis","editor/inspector/editor_properties.h"],
["EditorPropertyTransform3D","editor/inspector/editor_properties.h"],
["EditorPropertyProjection","editor/inspector/editor_properties.h"],
["EditorPropertyColor","editor/inspector/editor_properties.h"],
["EditorPropertyNodePath","editor/inspector/editor_properties.h"],
["EditorPropertyRID","editor/inspector/editor_properties.h"],
["EditorPropertyResource","editor/inspector/editor_properties.h"],
["EditorInspectorDefaultPlugin","editor/inspector/editor_properties.h"],
["EditorPropertyArrayObject","editor/inspector/editor_properties_array_dict.h"],
["EditorPropertyDictionaryObject","editor/inspector/editor_properties_array_dict.h"],
["EditorPropertyArray","editor/inspector/editor_properties_array_dict.h"],
["EditorPropertyDictionary","editor/inspector/editor_properties_array_dict.h"],
["EditorPropertyLocalizableString","editor/inspector/editor_properties_array_dict.h"],
["EditorPropertyVectorN","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector2","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector2i","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector3","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector3i","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector4","editor/inspector/editor_properties_vector.h"],
["EditorPropertyVector4i","editor/inspector/editor_properties_vector.h"],
["EditorPropertyNameProcessor","editor/inspector/editor_property_name_processor.h"],
["EditorResourcePicker","editor/inspector/editor_resource_picker.h"],
["EditorScriptPicker","editor/inspector/editor_resource_picker.h"],
["EditorShaderPicker","editor/inspector/editor_resource_picker.h"],
["EditorAudioStreamPicker","editor/inspector/editor_resource_picker.h"],
["EditorResourcePreviewGenerator","editor/inspector/editor_resource_preview.h"],
["EditorResourcePreview","editor/inspector/editor_resource_preview.h"],
["EditorResourceTooltipPlugin","editor/inspector/editor_resource_tooltip_plugins.h"],
["EditorTextureTooltipPlugin","editor/inspector/editor_resource_tooltip_plugins.h"],
["EditorAudioStreamTooltipPlugin","editor/inspector/editor_resource_tooltip_plugins.h"],
["SectionedInspector","editor/inspector/editor_sectioned_inspector.h"],
["InputEventConfigContainer","editor/inspector/input_event_editor_plugin.h"],
["EditorInspectorPluginInputEvent","editor/inspector/input_event_editor_plugin.h"],
["InputEventEditorPlugin","editor/inspector/input_event_editor_plugin.h"],
["MultiNodeEdit","editor/inspector/multi_node_edit.h"],
["PropertySelector","editor/inspector/property_selector.h"],
["EditorInspectorPluginSubViewportPreview","editor/inspector/sub_viewport_preview_editor_plugin.h"],
["SubViewportPreviewEditorPlugin","editor/inspector/sub_viewport_preview_editor_plugin.h"],
["EditorInspectorToolButtonPlugin","editor/inspector/tool_button_editor_plugin.h"],
["ToolButtonEditorPlugin","editor/inspector/tool_button_editor_plugin.h"],
["AudioStreamImportSettingsDialog","editor/import/audio_stream_import_settings.h"],
["DynamicFontImportSettingsData","editor/import/dynamic_font_import_settings.h"],
["DynamicFontImportSettingsDialog","editor/import/dynamic_font_import_settings.h"],
["EditorImportPlugin","editor/import/editor_import_plugin.h"],
["FBXImporterManager","editor/import/fbx_importer_manager.h"],
["ImportDefaultsEditor","editor/import/import_defaults_editor.h"],
["ResourceImporterBitMap","editor/import/resource_importer_bitmask.h"],
["ResourceImporterBMFont","editor/import/resource_importer_bmfont.h"],
["ResourceImporterCSVTranslation","editor/import/resource_importer_csv_translation.h"],
["ResourceImporterDynamicFont","editor/import/resource_importer_dynamic_font.h"],
["ResourceImporterImage","editor/import/resource_importer_image.h"],
["ResourceImporterImageFont","editor/import/resource_importer_imagefont.h"],
["LayeredTextureImport","editor/import/resource_importer_layered_texture.h"],
["ResourceImporterLayeredTexture","editor/import/resource_importer_layered_texture.h"],
["ResourceImporterShaderFile","editor/import/resource_importer_shader_file.h"],
["ResourceImporterSVG","editor/import/resource_importer_svg.h"],
["ResourceImporterTexture","editor/import/resource_importer_texture.h"],
["ResourceImporterTextureAtlas","editor/import/resource_importer_texture_atlas.h"],
["ResourceImporterWAV","editor/import/resource_importer_wav.h"],
["EditorSceneFormatImporterCollada","editor/import/3d/editor_import_collada.h"],
["PostImportPluginSkeletonRenamer","editor/import/3d/post_import_plugin_skeleton_renamer.h"],
["PostImportPluginSkeletonRestFixer","editor/import/3d/post_import_plugin_skeleton_rest_fixer.h"],
["PostImportPluginSkeletonTrackOrganizer","editor/import/3d/post_import_plugin_skeleton_track_organizer.h"],
["EditorOBJImporter","editor/import/3d/resource_importer_obj.h"],
["ResourceImporterOBJ","editor/import/3d/resource_importer_obj.h"],
["EditorSceneFormatImporter","editor/import/3d/resource_importer_scene.h"],
["EditorScenePostImport","editor/import/3d/resource_importer_scene.h"],
["EditorScenePostImportPlugin","editor/import/3d/resource_importer_scene.h"],
["ResourceImporterScene","editor/import/3d/resource_importer_scene.h"],
["EditorSceneFormatImporterESCN","editor/import/3d/resource_importer_scene.h"],
["SceneImportSettingsDialog","editor/import/3d/scene_import_settings.h"],
["GotoLinePopup","editor/gui/code_editor.h"],
["FindReplaceBar","editor/gui/code_editor.h"],
["CodeTextEditor","editor/gui/code_editor.h"],
["CreateDialog","editor/gui/create_dialog.h"],
["CreditsRoll","editor/gui/credits_roll.h"],
["DirectoryCreateDialog","editor/gui/directory_create_dialog.h"],
["EditorAbout","editor/gui/editor_about.h"],
["EditorBottomPanel","editor/gui/editor_bottom_panel.h"],
["EditorDirDialog","editor/gui/editor_dir_dialog.h"],
["EditorFileDialog","editor/gui/editor_file_dialog.h"],
["EditorObjectSelector","editor/gui/editor_object_selector.h"],
["HighlightedLabel","editor/gui/editor_quick_open_dialog.h"],
["QuickOpenResultContainer","editor/gui/editor_quick_open_dialog.h"],
["QuickOpenResultGridItem","editor/gui/editor_quick_open_dialog.h"],
["QuickOpenResultListItem","editor/gui/editor_quick_open_dialog.h"],
["QuickOpenResultItem","editor/gui/editor_quick_open_dialog.h"],
["EditorQuickOpenDialog","editor/gui/editor_quick_open_dialog.h"],
["EditorSpinSlider","editor/gui/editor_spin_slider.h"],
["EditorTitleBar","editor/gui/editor_title_bar.h"],
["EditorToaster","editor/gui/editor_toaster.h"],
["EditorValidationPanel","editor/gui/editor_validation_panel.h"],
["EditorVariantTypeOptionButton","editor/gui/editor_variant_type_selectors.h"],
["EditorVariantTypePopupMenu","editor/gui/editor_variant_type_selectors.h"],
["EditorVersionButton","editor/gui/editor_version_button.h"],
["EditorZoomWidget","editor/gui/editor_zoom_widget.h"],
["BackgroundProgress","editor/gui/progress_dialog.h"],
["ProgressDialog","editor/gui/progress_dialog.h"],
["TouchActionsPanel","editor/gui/touch_actions_panel.h"],
["WindowWrapper","editor/gui/window_wrapper.h"],
["ScreenSelect","editor/gui/window_wrapper.h"],
["DependencyEditor","editor/file_system/dependency_editor.h"],
["DependencyEditorOwners","editor/file_system/dependency_editor.h"],
["DependencyRemoveDialog","editor/file_system/dependency_editor.h"],
["DependencyErrorDialog","editor/file_system/dependency_editor.h"],
["OrphanResourcesDialog","editor/file_system/dependency_editor.h"],
["EditorFileSystemDirectory","editor/file_system/editor_file_system.h"],
["EditorFileSystemImportFormatSupportQuery","editor/file_system/editor_file_system.h"],
["EditorFileSystem","editor/file_system/editor_file_system.h"],
["EditorPaths","editor/file_system/editor_paths.h"],
["EditorExport","editor/export/editor_export.h"],
["EditorExportPlatform","editor/export/editor_export_platform.h"],
["EditorExportPlatformAppleEmbedded","editor/export/editor_export_platform_apple_embedded.h"],
["EditorExportPlatformExtension","editor/export/editor_export_platform_extension.h"],
["EditorExportPlatformPC","editor/export/editor_export_platform_pc.h"],
["EditorExportPlugin","editor/export/editor_export_plugin.h"],
["EditorExportPreset","editor/export/editor_export_preset.h"],
["ExportTemplateManager","editor/export/export_template_manager.h"],
["ProjectExportTextureFormatError","editor/export/project_export.h"],
["ProjectExportDialog","editor/export/project_export.h"],
["ShaderBakerExportPluginPlatform","editor/export/shader_baker_export_plugin.h"],
["EditorDock","editor/docks/editor_dock.h"],
["DockSplitContainer","editor/docks/editor_dock_manager.h"],
["EditorDockManager","editor/docks/editor_dock_manager.h"],
["EditorDockDragHint","editor/docks/editor_dock_manager.h"],
["DockContextPopup","editor/docks/editor_dock_manager.h"],
["FileSystemList","editor/docks/filesystem_dock.h"],
["FileSystemDock","editor/docks/filesystem_dock.h"],
["GroupsEditor","editor/docks/groups_editor.h"],
["HistoryDock","editor/docks/history_dock.h"],
["ImportDock","editor/docks/import_dock.h"],
["InspectorDock","editor/docks/inspector_dock.h"],
["NodeDock","editor/docks/node_dock.h"],
["SceneTreeDock","editor/docks/scene_tree_dock.h"],
["FindBar","editor/doc/editor_help.h"],
["EditorHelp","editor/doc/editor_help.h"],
["EditorHelpBit","editor/doc/editor_help.h"],
["EditorHelpBitTooltip","editor/doc/editor_help.h"],
["EditorHelpSearch","editor/doc/editor_help_search.h"],
["DebuggerEditorPlugin","editor/debugger/debugger_editor_plugin.h"],
["EditorDebuggerRemoteObjects","editor/debugger/editor_debugger_inspector.h"],
["EditorDebuggerInspector","editor/debugger/editor_debugger_inspector.h"],
["EditorDebuggerNode","editor/debugger/editor_debugger_node.h"],
["EditorDebuggerSession","editor/debugger/editor_debugger_plugin.h"],
["EditorDebuggerPlugin","editor/debugger/editor_debugger_plugin.h"],
["EditorDebuggerTree","editor/debugger/editor_debugger_tree.h"],
["EditorExpressionEvaluator","editor/debugger/editor_expression_evaluator.h"],
["EditorFileServer","editor/debugger/editor_file_server.h"],
["EditorPerformanceProfiler","editor/debugger/editor_performance_profiler.h"],
["EditorProfiler","editor/debugger/editor_profiler.h"],
["EditorVisualProfiler","editor/debugger/editor_visual_profiler.h"],
["ScriptEditorDebugger","editor/debugger/script_editor_debugger.h"],
["DebugAdapterParser","editor/debugger/debug_adapter/debug_adapter_parser.h"],
["DebugAdapterProtocol","editor/debugger/debug_adapter/debug_adapter_protocol.h"],
["DebugAdapterServer","editor/debugger/debug_adapter/debug_adapter_server.h"],
["AudioStreamEditor","editor/audio/audio_stream_editor_plugin.h"],
["EditorInspectorPluginAudioStream","editor/audio/audio_stream_editor_plugin.h"],
["AudioStreamEditorPlugin","editor/audio/audio_stream_editor_plugin.h"],
["AudioStreamPreview","editor/audio/audio_stream_preview.h"],
["AudioStreamPreviewGenerator","editor/audio/audio_stream_preview.h"],
["AudioStreamRandomizerEditorPlugin","editor/audio/audio_stream_randomizer_editor_plugin.h"],
["EditorAudioBus","editor/audio/editor_audio_buses.h"],
["EditorAudioBusDrop","editor/audio/editor_audio_buses.h"],
["EditorAudioBuses","editor/audio/editor_audio_buses.h"],
["EditorAudioMeterNotches","editor/audio/editor_audio_buses.h"],
["AudioBusesEditorPlugin","editor/audio/editor_audio_buses.h"],
["EditorAssetLibraryItem","editor/asset_library/asset_library_editor_plugin.h"],
["EditorAssetLibraryItemDescription","editor/asset_library/asset_library_editor_plugin.h"],
["EditorAssetLibraryItemDownload","editor/asset_library/asset_library_editor_plugin.h"],
["EditorAssetLibrary","editor/asset_library/asset_library_editor_plugin.h"],
["AssetLibraryEditorPlugin","editor/asset_library/asset_library_editor_plugin.h"],
["EditorAssetInstaller","editor/asset_library/editor_asset_installer.h"],
["AnimationBezierTrackEdit","editor/animation/animation_bezier_editor.h"],
["AnimationNodeBlendSpace1DEditor","editor/animation/animation_blend_space_1d_editor.h"],
["AnimationNodeBlendSpace2DEditor","editor/animation/animation_blend_space_2d_editor.h"],
["AnimationNodeBlendTreeEditor","editor/animation/animation_blend_tree_editor_plugin.h"],
["EditorInspectorPluginAnimationNodeAnimation","editor/animation/animation_blend_tree_editor_plugin.h"],
["AnimationNodeAnimationEditorDialog","editor/animation/animation_blend_tree_editor_plugin.h"],
["AnimationNodeAnimationEditor","editor/animation/animation_blend_tree_editor_plugin.h"],
["AnimationLibraryEditor","editor/animation/animation_library_editor.h"],
["AnimationPlayerEditor","editor/animation/animation_player_editor_plugin.h"],
["AnimationPlayerEditorPlugin","editor/animation/animation_player_editor_plugin.h"],
["EditorInspectorPluginAnimationTrackKeyEdit","editor/animation/animation_player_editor_plugin.h"],
["AnimationTrackKeyEditEditorPlugin","editor/animation/animation_player_editor_plugin.h"],
["EditorInspectorPluginAnimationMarkerKeyEdit","editor/animation/animation_player_editor_plugin.h"],
["AnimationMarkerKeyEditEditorPlugin","editor/animation/animation_player_editor_plugin.h"],
["AnimationNodeStateMachineEditor","editor/animation/animation_state_machine_editor.h"],
["EditorAnimationMultiTransitionEdit","editor/animation/animation_state_machine_editor.h"],
["AnimationTrackKeyEdit","editor/animation/animation_track_editor.h"],
["AnimationMultiTrackKeyEdit","editor/animation/animation_track_editor.h"],
["AnimationMarkerKeyEdit","editor/animation/animation_track_editor.h"],
["AnimationMultiMarkerKeyEdit","editor/animation/animation_track_editor.h"],
["AnimationTimelineEdit","editor/animation/animation_track_editor.h"],
["AnimationMarkerEdit","editor/animation/animation_track_editor.h"],
["AnimationTrackEdit","editor/animation/animation_track_editor.h"],
["AnimationTrackEditPlugin","editor/animation/animation_track_editor.h"],
["AnimationTrackEditGroup","editor/animation/animation_track_editor.h"],
["AnimationTrackEditor","editor/animation/animation_track_editor.h"],
["AnimationTrackKeyEditEditor","editor/animation/animation_track_editor.h"],
["AnimationMarkerKeyEditEditor","editor/animation/animation_track_editor.h"],
["AnimationTrackEditBool","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditColor","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditAudio","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditSpriteFrame","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditSubAnim","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditTypeAudio","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditTypeAnimation","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditVolumeDB","editor/animation/animation_track_editor_plugins.h"],
["AnimationTrackEditDefaultPlugin","editor/animation/animation_track_editor_plugins.h"],
["AnimationTreeNodeEditorPlugin","editor/animation/animation_tree_editor_plugin.h"],
["AnimationTreeEditor","editor/animation/animation_tree_editor_plugin.h"],
["AnimationTreeEditorPlugin","editor/animation/animation_tree_editor_plugin.h"],
["IPWindows","drivers/windows/ip_windows.h"],
["IPUnix","drivers/unix/ip_unix.h"],
["RenderSceneBuffersGLES3","drivers/gles3/storage/render_scene_buffers_gles3.h"],
["AppleEmbedded","drivers/apple_embedded/apple_embedded.h"],
["ResourceLoader","core/core_bind.h"],
["ResourceSaver","core/core_bind.h"],
["Logger","core/core_bind.h"],
["OS","core/core_bind.h"],
["Geometry2D","core/core_bind.h"],
["Geometry3D","core/core_bind.h"],
["Marshalls","core/core_bind.h"],
["Mutex","core/core_bind.h"],
["Semaphore","core/core_bind.h"],
["Thread","core/core_bind.h"],
["ClassDB","core/core_bind.h"],
["Engine","core/core_bind.h"],
["EngineDebugger","core/core_bind.h"],
["OptimizedTranslation","core/string/optimized_translation.h"],
["Translation","core/string/translation.h"],
["TranslationDomain","core/string/translation_domain.h"],
["TranslationPO","core/string/translation_po.h"],
["TranslationServer","core/string/translation_server.h"],
["MainLoop","core/os/main_loop.h"],
["Time","core/os/time.h"],
["m_class","core/object/object.h"],
["RefCounted","core/object/ref_counted.h"],
["WeakRef","core/object/ref_counted.h"],
["ScriptBacktrace","core/object/script_backtrace.h"],
["Script","core/object/script_language.h"],
["ScriptLanguage","core/object/script_language.h"],
["ScriptExtension","core/object/script_language_extension.h"],
["ScriptLanguageExtension","core/object/script_language_extension.h"],
["UndoRedo","core/object/undo_redo.h"],
["WorkerThreadPool","core/object/worker_thread_pool.h"],
["AStar3D","core/math/a_star.h"],
["AStar2D","core/math/a_star.h"],
["AStarGrid2D","core/math/a_star_grid_2d.h"],
["Expression","core/math/expression.h"],
["RandomNumberGenerator","core/math/random_number_generator.h"],
["StaticRaycaster","core/math/static_raycaster.h"],
["TriangleMesh","core/math/triangle_mesh.h"],
["ConfigFile","core/io/config_file.h"],
["DirAccess","core/io/dir_access.h"],
["DTLSServer","core/io/dtls_server.h"],
["FileAccess","core/io/file_access.h"],
["HTTPClient","core/io/http_client.h"],
["Image","core/io/image.h"],
["ImageFormatLoader","core/io/image_loader.h"],
["ImageFormatLoaderExtension","core/io/image_loader.h"],
["IP","core/io/ip.h"],
["JSON","core/io/json.h"],
["EncodedObjectAsID","core/io/marshalls.h"],
["MissingResource","core/io/missing_resource.h"],
["PackedDataContainer","core/io/packed_data_container.h"],
["PackedDataContainerRef","core/io/packed_data_container.h"],
["PacketPeer","core/io/packet_peer.h"],
["PacketPeerExtension","core/io/packet_peer.h"],
["PacketPeerStream","core/io/packet_peer.h"],
["PacketPeerDTLS","core/io/packet_peer_dtls.h"],
["PacketPeerUDP","core/io/packet_peer_udp.h"],
["PCKPacker","core/io/pck_packer.h"],
["Resource","core/io/resource.h"],
["ResourceImporter","core/io/resource_importer.h"],
["ResourceFormatImporterSaver","core/io/resource_importer.h"],
["ResourceFormatLoader","core/io/resource_loader.h"],
["ResourceFormatSaver","core/io/resource_saver.h"],
["ResourceUID","core/io/resource_uid.h"],
["SocketServer","core/io/socket_server.h"],
["StreamPeer","core/io/stream_peer.h"],
["StreamPeerExtension","core/io/stream_peer.h"],
["StreamPeerBuffer","core/io/stream_peer.h"],
["StreamPeerGZIP","core/io/stream_peer_gzip.h"],
["StreamPeerSocket","core/io/stream_peer_socket.h"],
["StreamPeerTCP","core/io/stream_peer_tcp.h"],
["StreamPeerTLS","core/io/stream_peer_tls.h"],
["StreamPeerUDS","core/io/stream_peer_uds.h"],
["TCPServer","core/io/tcp_server.h"],
["UDPServer","core/io/udp_server.h"],
["UDSServer","core/io/uds_server.h"],
["XMLParser","core/io/xml_parser.h"],
["Input","core/input/input.h"],
["InputEvent","core/input/input_event.h"],
["InputEventFromWindow","core/input/input_event.h"],
["InputEventWithModifiers","core/input/input_event.h"],
["InputEventKey","core/input/input_event.h"],
["InputEventMouse","core/input/input_event.h"],
["InputEventMouseButton","core/input/input_event.h"],
["InputEventMouseMotion","core/input/input_event.h"],
["InputEventJoypadMotion","core/input/input_event.h"],
["InputEventJoypadButton","core/input/input_event.h"],
["InputEventScreenTouch","core/input/input_event.h"],
["InputEventScreenDrag","core/input/input_event.h"],
["InputEventAction","core/input/input_event.h"],
["InputEventGesture","core/input/input_event.h"],
["InputEventMagnifyGesture","core/input/input_event.h"],
["InputEventPanGesture","core/input/input_event.h"],
["InputEventMIDI","core/input/input_event.h"],
["InputEventShortcut","core/input/input_event.h"],
["InputMap","core/input/input_map.h"],
["Shortcut","core/input/shortcut.h"],
["GDExtension","core/extension/gdextension.h"],
["GDExtensionManager","core/extension/gdextension_manager.h"],
["GodotInstance","core/extension/godot_instance.h"],
["EngineProfiler","core/debugger/engine_profiler.h"],
["AESContext","core/crypto/aes_context.h"],
["CryptoKey","core/crypto/crypto.h"],
["X509Certificate","core/crypto/crypto.h"],
["TLSOptions","core/crypto/crypto.h"],
["HMACContext","core/crypto/crypto.h"],
["Crypto","core/crypto/crypto.h"],
["HashingContext","core/crypto/hashing_context.h"],
["ProjectSettings","core/config/project_settings.h"]
    ]
  );
}
